import common from './common';
import featuresPay from './feature';

const ko = {
    featuresPay,
    common,
    SerialNumberDrawer: {
        productVariants: "제품/변형",
        serialNumber: "일련 번호",
        noProductsFound: "제품을 찾을 수 없습니다",
        searchByProductSku: "제품/SKU로 검색",
        searchSerialNumbers: "일련 번호 검색",
        transactionDetails: "거래 세부 정보",
        notAvailable: "해당 없음",
        mainWarehouse: "메인 창고"
    },
    new_build_banner: {
        title: '새 버전:',
        is_available: '을(를) 이제 사용할 수 있습니다',
        fallback_title: '앱의 새 버전을 사용할 수 있습니다',
        desc: '최신 기능과 개선 사항을 보려면 새로고침하세요.',
        refreshing: '새로고침 중…',
        refresh_now: '지금 새로고침',
        later: '나중에',
        you_are_on: "현재 버전"
    },
    short: {
        finance: '재무',
        stock: '재고'
    },
    onboarding: {
        welcome: '환영합니다!',
        step: {
            product: {
                totalBreakdown: '전체 내역',
                overallFulfilment: '전체 이행률',
                totalShippedQty: '총 배송 수량',
                totalReceivedQty: '총 입고 수량',
                totalOrderedQty: '총 주문 수량',
                totalShippedOrdered: '총 배송 / 주문',
                totalReceivedOrdered: '총 입고 / 주문',
                viewQty: '수량 보기',
                fetchingQty: '수량 세부정보를 가져오는 중...',
                noStockInfo: '재고 정보를 찾을 수 없습니다',
                title: '65% 달성',
                description: '성공을 시작하려면 단 2단계만 남았습니다!',
                Warehouse: "창고",
            },
            stock: {
                title: '95% 거의 완료!!',
                description: '단 한 단계만 더 남았습니다! 지금 바로 완료하세요.'
            }
        },
        business: {
            title: '비즈니스가 성공적으로 생성되었습니다!',
            description: '좋아요! 비즈니스가 등록되었습니다'
        },
        product: {
            title: '첫 번째 상품 추가',
            description: '재고 기록을 시작하려면 상품을 추가하세요',
            Warehouse: "창고",
        },
        stock: {
            title: '재고를 추가해보세요',
            description: '입출고 재고 기록을 시작하세요'
        },
        action: {
            add_business: {
                title: '비즈니스 생성',
                description: '새 비즈니스를 생성하시겠습니까? 여기를 클릭하세요'
            },
            join_business: {
                title: '비즈니스 참여',
                description: '초대 코드가 있나요? 여기에서 참여하세요'
            }
        }
    },
    business: {
        title: '비즈니스를 선택, 새로 생성 또는 참여',
        add_business: {
            title: '새 비즈니스 생성',
            name: '비즈니스 이름',
            name_placeholder: '이름을 입력하세요',
            category: '비즈니스 카테고리',
            category_placeholder: '카테고리 선택',
            button: '비즈니스 생성'
        },
        edit_business: {
            title: '비즈니스 편집'
        },
        join_business: {
            title: '비즈니스 참여',
            input_code: '아래에 초대 코드를 입력하세요:',
            field_placeholder: '초대 코드',
            confirm_title: '참여',
            confirm_text: '다음 팀의 일원이 됩니다 '
        },
        no_business: '사용 가능한 비즈니스가 없습니다',
        create_or_join: '비즈니스 생성 또는 참여',
        message: {
            saved: '비즈니스가 성공적으로 저장되었습니다!'
        },
        settings: {
            isNegativeTransactionDisabled: '마이너스 재고 거래',
            isNegativeTransactionDisabledHint: '이 설정을 켜면 재고가 마이너스가 되는 거래를 방지할 수 있습니다.',
            negativeStockError: '마이너스 재고 거래가 비활성화되었습니다'
        }
    },
    profile: {
        edit_profile: {
            title: '프로필 편집',
            name: '이름',
            name_placeholder: '이름을 입력하세요',
            email: '이메일',
            phone_number: '전화번호'
        },
        message: {
            required_name: '이름은 필수 항목입니다'
        }
    },
    product: {
        weightedAverageCost: '가중 평균 원가',
        weightedAverageValueLabel: '가중 평균 가치',
        Product: '제품',
        hideZeroStock: '재고 0 숨기기',
        allVariants: '모든 변형',
        choose_product: '상품 선택',
        choose_product_empty: '상품을 선택하고 수량을 입력하세요',
        choose_product_empty_manufacturing: '상품을 선택하고 제조 수량을 입력하세요',
        search: {
            placeholder: '이름으로 검색',
            tooltip: '스캐너 열기',
            Warehouse: "창고",
        },
        column: {
            image: '사진',
            name: '이름',
            price: '가격',
            buying_price: '원가',
            selling_price: '판매가',
            sku: 'SKU',
            stock: '재고',
            quantity: '수량',
            latest_stock: '남은 수량',
            product_deleted: '상품이 삭제되었습니다',
            info_not_found: '정보를 사용할 수 없습니다',
            expired_date: '유효 기간',
            invoice: '송장'
        },
        no_product: '상품이 없습니다',
        no_product_subtitle: '첫 번째 제품을 추가하여 재고, 가격 및 판매 추적을 시작하세요.',
        create_first_product: '첫 번째 제품 만들기',
        add_product: {
            sku: '상품 코드',
            sku_placeholder: '상품 코드 예: 12345',
            name: '상품명',
            name_placeholder: '상품명을 입력하세요',
            initial_stock: '초기 재고',
            initial_stock_placeholder: '초기 재고를 입력하세요',
            buying_price: '원가',
            buying_price_placeholder: '원가를 입력하세요',
            selling_price: '판매가',
            selling_price_placeholder: '판매가를 입력하세요',
            category: '카테고리',
            category_placeholder: '카테고리 선택',
            add_selling_price: '도매가 추가',
            expired_date: '유효 기간',
            expired_date_placeholder: '날짜 선택',
            description: '설명',
            description_placeholder: '설명을 입력하세요',
            custom_label: '속성',
            custom_label_placeholder: '키 입력',
            add_custom_label: '속성 추가',
            Warehouse: "창고",
        },
        customerLabel: {},
        choose_selling_price: '판매가 선택',
        selling_price: '판매가',
        total_product: '총 상품',
        total_quantity: '총 재고 수량',
        total_buying_price: '총 원가',
        total_selling_price: '총 판매가',
        message: {
            required_name: '상품명은 필수입니다',
            required_sku: 'SKU는 필수입니다',
            required_category: '카테고리는 필수입니다',
            required_quantity: '초기 재고는 필수입니다',
            invalid_input_qty: '잘못된 재고 수량입니다',
            required_buying_price: '원가는 필수입니다',
            required_selling_price: '판매가는 필수입니다',
            required_selling_price_name: '판매가 이름은 필수입니다',
            required_selling_price_price: '판매가는 필수입니다'
        },
        viewMore: '더 보기',
        WarehouseDetails: '창고 세부정보',
        WarehouseName: '창고 이름',
        AddWarehouse: '창고 추가',
        WarehouseQty: '창고 수량',
        Warehouse: '창고',
        Warehouses: '창고',
        Variants: '옵션',
        VariantName: '옵션명',
        productVariant: '상품 옵션',
        AddVariant: '옵션 추가',
        TranferItem: '아이템 전송',
        AddUnit: '새 단위',
        InitialStkWarehouse: '옵션을 추가하려면 초기 재고가 필요합니다',
        InitialStockinwarehouse: '창고의 초기 재고',
        TotalQuantity: '총 수량:',
        AddNote: '메모 추가(원가)',
        AddNotetitle: '메모 추가',
        VariantSuccessMessage: '상품 옵션이 성공적으로 업데이트되었습니다',
        Next: '다음',
        Submit: '제출',
        INACTIVE: '비활성화됨',
        errorone: '죄송합니다! 요청한 수량이',
        errortwo: '할당된 창고 수량과 일치하지 않습니다. 수량을 조정하거나 재입고하세요.',
        SelectWarehouse: '창고 선택',
        SelectVariant: '옵션 선택',
        Discount: '할인',
        DiscountDetails: '할인 세부정보',
        FinalPrice: '최종 가격',
        DiscountType: '할인 유형',
        DiscountPer: '할인%',
        DiscountValue: '할인 금액',
        Discountonprice: '가격에 대한 할인',
        Discountondiscount: '할인에 대한 할인',
        AdditionalDiscount: '추가 할인',
        SellingPrice: '판매가:',
        Save: '저장',
        OnOriginalPrice: '원가 기준',
        OnDiscountedPrice: '할인가 기준',
        columnSelector: {
            title: '열 표시',
            columnsButton: '열',
            costPrice: '구매 가격',
            sellingPrice: '판매 가격',
            sku: 'SKU',
            warehouse: '창고',
            categories: '카테고리',
            safetyStock: '안전 재고',
            attributes: '속성',
            notes: '메모',
            description: '설명',
            more: '더보기',
            attribute: '속성',
            attributesTitle: '속성',
            categoriesTitle: '카테고리',
            skuAliases: 'SKU 에일리어스'
        }
    },
    note: {
        title: '메모',
        add: '메모 추가',
        no_note: '사용 가능한 메모가 없습니다'
    },
    settings: {
        category: '카테고리',
        language: '언어',
        switch_business: '비즈니스 전환',
        currencySelect: '통화',
        languageChangeSuccess: '통화가 성공적으로 업데이트되었습니다',
        languageChangeErrorMessage: '통화를 업데이트하는 동안 문제가 발생했습니다',
        currencyAdded: "통화가 성공적으로 추가되었습니다",
        currencyDelete: "통화가 성공적으로 삭제되었습니다",
        Selectyourpreferredlanguage: "선호하는 언어를 선택하세요",
    },
    selectProductStock: '상품 선택',
    category: {
        category_list: {
            title: '상품 카테고리'
        },
        add_category: {
            button: '새 카테고리',
            title: '새 카테고리 추가'
        },
        edit_category: {
            title: '카테고리 편집'
        },
        name: '카테고리 이름',
        name_placeholder: '카테고리 이름 입력',
        no_category: '사용 가능한 카테고리가 없습니다'
    },
    staff: {
        add: '직원 추가',
        edit: '직원 편집',
        access: {
            stock: '재고',
            add_product: '새 상품 추가',
            edit_product: '상품 편집',
            delete_product: '상품 삭제',
            view_capital_price: '원가 보기',
            add_category: '새 카테고리 추가',
            edit_category: '카테고리 편집',
            delete_category: '카테고리 삭제',
            add_supplier: '새 공급업체 추가',
            edit_supplier: '공급업체 편집',
            delete_supplier: '공급업체 삭제',
            add_customer: '새 고객 추가',
            edit_customer: '고객 편집',
            delete_customer: '고객 삭제',
            add_staff: '직원 추가',
            edit_staff: '직원 편집',
            delete_staff: '직원 삭제',
            change_business_profile: '비즈니스 프로필 변경',
            access_by_product_category: '제품 카테고리별 접근',
            no_category_message: '추가된 카테고리가 없습니다. 카테고리를 추가해주세요.',
            expenses: '지출',
            view_expenses: '지출 보기',
            add_expenses: '지출 추가',
            edit_expenses: '지출 편집',
            delete_expenses: '지출 삭제',
            warehouse: '창고',
            add_new_warehouse: '새 창고 추가',
            edit_warehouse: '창고 편집',
            delete_warehouse: '창고 삭제',
            transfer_warehouse: '창고 이전',
            transfer_warehouse_approval: '창고 이전 승인',
            access_by_warehouse: '창고별 접근',
            no_warehouse_message: '추가된 창고가 없습니다. 창고 목록을 추가하세요.',
            purchase_order: "구매 주문",
            purchase_order_creation: "구매 주문 생성",
            purchase_order_edit: "구매 주문 편집",
            purchase_order_cancel: "구매 주문 취소",
            purchase_order_reopen: "구매 주문 재개",
            purchase_order_receive: "구매 주문 수령",
            sales_order: "판매 주문",
            sales_order_creation: "판매 주문 생성",
            sales_order_edit: "판매 주문 편집",
            sales_order_cancel: "판매 주문 취소",
            sales_order_reopen: "판매 주문 재개",
            sales_order_receive: "판매 주문 배송됨",
            purchase_order_approval: "구매 주문 승인",
            sales_order_approval: "판매 주문 승인",
            can_do_available_warehouse: "사용 가능한 창고",
            add_batch: "배치 생성 승인"
            ,
            notification: '알림',
            staffNotification: '알림 활성화',
            assignee: "담당자",
        },
        no_staff: '직원이 없습니다.'
    },
    code: {
        title: '새 직원이 추가되었습니다!',
        subtitle: '아래 초대 코드를 공유하여 참여하세요:',
        valid: '코드는 48시간 동안만 유효합니다',
        share: 'WhatsApp으로 공유',
        copied: '복사되었습니다!',
        invalid: '잘못된 코드입니다!'
    },
    history: {
        no_history: '기록이 없습니다.',
        detail: {
            remove: '기록 삭제',
            confirm: '이 기능은 기존 재고, 기록 및 보고서에 영향을 미칩니다.'
        },
        no_history_selected: "선택된 기록이 없습니다",
        select_history_hint: "세부 정보를 보려면 목록에서 기록을 클릭하세요",
        select_from_left: "왼쪽 패널에서 선택하세요",
    },
    supplier: {
        add: {
            title: '공급업체 추가'
        },
        edit: {
            title: '공급업체 편집'
        },
        new: '새 공급업체',
        no_supplier: '공급업체가 없습니다.',
        bank: {
            title: '은행 정보'
        },
        note: '메모',
        form: {
            name: {
                label: '공급업체 이름',
                placeholder: '공급업체 이름 입력',
                placheolder_not_mandatory: '이름 입력',
                error: {
                    required: '이름은 비워둘 수 없습니다'
                }
            },
            contact: {
                label: '연락처 번호',
                placeholder: '91934554432',
                error: {
                    required: '연락처 번호는 비워둘 수 없습니다',
                    invalid: '잘못된 번호입니다. 국가 코드를 포함해야 합니다'
                }
            },
            bank_name: {
                label: '은행명',
                placeholder: '은행명 입력'
            },
            bank_account_name: {
                label: '계좌 예금주명',
                placeholder: '예금주명 입력'
            },
            bank_account_number: {
                label: '계좌번호',
                placeholder: '계좌번호 입력'
            },
            note: {
                label: '메모',
                placeholder: '메모 추가'
            },
            openingBalance: {
                addBtn: '기초 잔액 추가',
                label: '기초 잔액',
                placeholder: '기초 잔액 입력',
                error: {
                    negative: '기초 잔액은 음수가 될 수 없습니다'
                }
            }
        },
        choose: '공급업체 선택'
    },
    customer: {
        add: {
            title: '고객 추가'
        },
        edit: {
            title: '고객 편집'
        },
        new: '새 고객',
        no_customer: '고객이 없습니다.',
        note: '메모',
        form: {
            name: {
                label: '고객 이름',
                placeholder: '고객 이름 입력',
                placheolder_not_mandatory: '이름 입력',
                error: {
                    required: '이름은 비워둘 수 없습니다'
                }
            },
            contact: {
                label: '연락처 번호',
                placeholder: '91934554432',
                error: {
                    required: '연락처 번호는 비워둘 수 없습니다',
                    invalid: '잘못된 번호입니다. 국가 코드를 포함해야 합니다'
                }
            },
            address: {
                label: '주소',
                placeholder: '주소 입력'
            },
            note: {
                label: '메모',
                placeholder: '메모 추가'
            },
            openingBalance: {
                addBtn: '기초 잔액 추가',
                label: '기초 잔액',
                placeholder: '기초 잔액 입력',
                error: {
                    negative: '기초 잔액은 음수가 될 수 없습니다'
                }
            }
        },
        choose: "고객 선택",
        report: {
            view: '구매자 보고서 보기',
            title: '고객 보고서',
            no_report: '선택한 날짜의 보고서가 없습니다.',
            column: {
                name: '이름',
                total_transaction: '총 거래 수',
                total_amount: '총 매출',
                total_profit: '총 이익'
            }
        }
    },
    confirm_delete: '이 데이터를 삭제하시겠습니까?',
    report: {
        title: '보고서'
    },
    accounting: {
        download_pdf_report: 'PDF 다운로드',
        title: '회계',
        view_report: '재무 보고서 보기',
        dashboard_title: '재무 보고서',
        stats: '통계',
        accounting_report: '회계 보고서',
        filter: {
            date: {
                placeholder: '날짜 선택',
                submit: '적용',
                cancel: '필터 재설정'
            },
            timeframe: {
                day: '일간',
                week: '주간',
                month: '월간',
                year: '연간'
            }
        },
        total_sales: '총 매출',
        total_purchases: '총 매입',
        total_profit: '총 이익',
        total_expenses: '총 지출',
        assets_value: '현재 자산 가치',
        total_current_cogs_value: '현재 총 COGS 금액',
        current_asset_selling_price: '현재 자산 판매 가격',
        total_selling_price: '총 판매 가격',
        table: {
            date: '날짜',
            sales: '매출',
            purchases: '매입',
            profit: '이익',
            expenses: '지출'
        },
        no_data: '데이터가 없습니다.'
    },
    stock_report: {
        title: '재고 보고서',
        view: '재고 보고서 보기',
        no_report: '선택한 날짜 또는 직원에 대한 재고 기록이 없습니다.',
        allStaffPlaceHolder: '전체 직원',
        column: {
            total_product: '현재 상품 유형',
            total_product_quantity: '현재 총 상품 수'
        }
    },
    subscription: {
        paywall_small: {
            title: 'VIP 기능',
            description:
                '이 기능의 체험 기간이 종료되었습니다. 구독하여 이 로컬 앱의 개발을 지원해 주세요.',
            button: '구독 플랜 보기'
        }
    },
    payment: {
        order: {
            title: '결제'
        }
    },
    imageUploadMessage: {
        uploadSize: '이미지 크기는 5MB를 초과할 수 없습니다!',
        failedMessage: '상품 이미지 업로드에 실패했습니다. 다시 시도해 주세요!',
        successUpload: '이미지가 성공적으로 업로드되었습니다!',
        failedUIError: '이미지 삭제에 실패했습니다. 다시 시도해 주세요!',
        SuccessErrorImage: '이미지가 성공적으로 삭제되었습니다!'
    },
    productColumns: {
        SKULabel: 'SKU',
        nameLabel: '상품명',
        categoryLabel: '카테고리',
        BuyingPriceLabel: '매입 가격',
        SellingLabel: '판매 가격',
        StockLabel: '재고'
    },
    historyColumns: {
        Transactionlabel: '거래 유형',
        Locallabel: '현지 시간',
        Createdlabel: '작성자',
        Vendorlabel: '공급업체명',
        Buyerlabel: '구매자명',
        SKUlabel: 'SKU',
        Invoicelabel: '송장',
        Productlabel: '상품명',
        Categorylabel: '카테고리',
        Buyinglabel: '매입 가격',
        Sellinglabel: '판매 가격',
        Initiallabel: '초기 재고',
        Finallabel: '최종 재고',
        Stocklabel: '재고 변동'
    },
    stockReportColumns: {
        skuLabel: 'SKU',
        productNameLabel: '상품명',
        categoryLabel: '카테고리',
        buyingPriceLabel: '매입 가격',
        sellingPriceLabel: '판매 가격',
        stockInLabel: '입고 재고',
        stockOutLabel: '출고 재고',
        remainingStockLabel: '남은 재고',
        openStockLabel: '초기 재고',
        weightedAverageCost: '가중 평균 원가',
        weightedAverageCostLabel: '가중 평균 원가',
        weightedAverageValueLabel: '가중 평균 가치'
    },
    accountingReportColumns: {
        dateRange: '날짜 범위',
        reportingPeriod: '보고 기간',
        reportGenerate: '보고서 생성',
        warehouse: '창고',
        labelDate: '날짜',
        labelSales: '매출',
        labelPurchases: '매입',
        labelProfit: '이익',
        labelExpenses: '지출',
        reportOptions: '보고서 열',
        summaryCards: '요약 카드',
        grandTotal: '총합계',
        continued: '계속',
        subtotal: '소계',
        page: '페이지'
    },
    customerReportColumns: {
        labelName: '이름',
        labelTotalTransaction: '총 거래 수',
        labelTotalSales: '총 매출',
        labelTotalProfit: '총 이익'
    },
    scannerDialog: {
        finished: '완료',
        reduce: '줄이기',
        successfull: '성공',
        searching: '검색 중...',
        title: '스캐너가 활성화되었습니다. 바코드에 비추세요!'
    },
    historyFilter: {
        SelectBuyer: '구매자 선택',
        SelectVendor: '공급업체 선택'
    },
    productStockFilter: {
        StockLowtoHigh: '재고 적은 순',
        StockHightoLow: '재고 많은 순',
        AlphabetAZ: '알파벳 A-Z',
        AlphabetZA: '알파벳 Z-A'
    },
    minimizeTitle: '스캐너 활성화',
    security_guarantee: {
        title: '데이터 보안 보장'
    },
    invoice: {
        invoicePlaceholder: '송장 번호',
        invoiceTitle: '송장',
        manageInvoiceAddress: '청구서 주소 관리',
        selectOrManageAddresses: '맞춤 청구서 주소 선택, 편집 또는 생성',
        useBusinessProfileAddress: '비즈니스 프로필 주소 사용',
        noCustomAddressesFound: '추가된 맞춤 주소가 없습니다',
        createCustomAddressDesc: '기본 비즈니스 프로필 데이터 대신 청구서에 인쇄할 맞춤 청구 또는 지점 주소를 추가하세요.',
        defaultFromBusinessProfile: '비즈니스 프로필의 기본값',
        editInvoiceAddress: '청구서 주소 편집',
        createNewInvoiceAddress: '새 청구서 주소 생성',
        logoHeaderImage: '로고 / 헤더 이미지',
        deleteInvoiceAddress: '청구서 주소를 삭제하시겠습니까?',
        deleteAddressConfirmText: '이 청구서 주소를 삭제하시겠습니까? 이 작업은 취소할 수 없습니다.'
    },
    ManageInvoiceAddress: '청구서 주소 관리',
    SelectOrManageAddresses: '맞춤 청구서 주소 선택, 편집 또는 생성',
    UseBusinessProfileAddress: '비즈니스 프로필 주소 사용',
    CreateNewAddress: '새 주소 생성',
    UpdatingList: '목록 업데이트 중...',
    NoCustomAddressesFound: '추가된 맞춤 주소가 없습니다',
    CreateCustomAddressDesc: '기본 비즈니스 프로필 데이터 대신 청구서에 인쇄할 맞춤 청구 또는 지점 주소를 추가하세요.',
    DefaultFromBusinessProfile: '비즈니스 프로필의 기본값',
    EditInvoiceAddress: '청구서 주소 편집',
    CreateNewInvoiceAddress: '새 청구서 주소 생성',
    LogoHeaderImage: '로고 / 헤더 이미지',
    UploadingImage: '이미지 업로드 중...',
    UploadImage: '이미지 업로드',
    BusinessName: '사업체 이름',
    AddressDetails: '주소 세부 정보',
    PhoneNumber: '전화번호',
    EmailAddress: '이메일 주소',
    DeleteInvoiceAddress: '청구서 주소를 삭제하시겠습니까?',
    DeleteAddressConfirmText: '이 청구서 주소를 삭제하시겠습니까? 이 작업은 취소할 수 없습니다.',

    stocklowreport: {
        no_stocklowreport_one: '안전 재고 설정이 있는 상품이 없습니다.',
        no_stocklowreport_two: '안전 재고 수량을 추가해 주세요.',
        currentStock: '현재 재고',
        safetyStock: '안전 재고',
        pricing: '가격 설정',
        costPrice: '원가',
        sellingPrice: '판매 가격',
        productInfo: '제품 정보',
        category: '카테고리',
        description: '설명',
        no_description: '설명이 추가되지 않았습니다',
        variants: '옵션',
        unitsOnHand: '보유 수량',
        minimumThreshold: '최소 기준치',
        adjust: '조정',
        all: '전체',
        lowStock: '재고 부족',
        variantsDetails: '옵션 상세 정보',
        qty: '수량',
        addSafetyStock: '안전 재고 추가',
        searchByNameSku: '이름/SKU로 검색',
        safetyStockShort: '안',
        warehouseSafetyStock: '창고 안전 재고'
    },
    low_alert_stock: '안전 재고 수량 입력',
    lowStockAlertNotify: '설정한 수량 이하로 재고가 떨어지면 알림을 받습니다',
    applyButtonStockAlert: '적용',
    cancelButtonStockAlert: '취소',
    searchProductLabel: '상품 검색...',
    successfullyAddedSafetyStock: '안전 재고가 성공적으로 업데이트되었습니다',
    safety_Stock: '안전 재고',
    safety_stock_placeholder: '안전 재고 입력',
    lowStockDetailsInfo: {
        ProductCode: '상품 코드',
        SafetyStock: '안전 재고',
        Stock: '재고',
        CostPrice: '매입 가격',
        SellingPrice: '판매 가격',
        Category: '카테고리',
        Description: '설명',
        ExpirationDate: '유효 기간'
    },
    CustomLang: {
        Attribute: '속성',
        AddAttribute: '속성 추가',
        EditAttribute: '속성 편집',
        CustomLabePlaceholder: '속성명 입력',
        CustomLabePlaceholderSelect: '유형 선택',
        AddMoreAttribute: '속성 더 추가',
        ItemAttribute: '상품 속성',
        TableName: '이름',
        TableType: '유형',
        TableAction: '작업',
        TableDelete: '삭제',
        TableEdit: '편집',
        deleteMessage: '속성이 성공적으로 삭제되었습니다',
        editSuccessMessage: '속성이 성공적으로 업데이트되었습니다',
        AddSuccessMessage: '속성이 성공적으로 추가되었습니다',
        AddAtt: '추가',
        EditAtt: '편집',
        SubmitAtt: '제출 중...'
    },
    Expenses: {
        ExpensesTitle: '경비',
        AddExpenses: '경비 추가',
        ExpenseCategory: '경비 카테고리',
        NoExpenseCategory: '경비 카테고리가 없습니다',
        AddExpenseCategory: '경비 카테고리 추가',
        SelectExpenseCategory: '경비 카테고리 선택',
        NoExpenses: '경비가 없습니다',
        ExpensesSuccess: '경비가 성공적으로 생성되었습니다',
        ExpensesSuccessEdit: '경비가 성공적으로 업데이트되었습니다',
        ExpensesCategoryName: '경비 카테고리명',
        ExpensesSuccessDelete: '경비가 성공적으로 삭제되었습니다',
        AddNEC: "새 비용 카테고리 추가",
        NC: "새 비용 카테고리",
        EditNEC: "비용 카테고리 수정"
    },
    Manufacturing: {
        ProducedProduct: "생산된 제품",
        QuantityManufactured: "생산 수량",
        UnitCost: "단위 비용",
        RawMaterialsTotal: "원자재 총합",
        TotalManufacturingCost: "총 제조 비용",
        NoRawMaterialsConsumed: "원자재 소모 없음.",
        CostBreakdown: "비용 분석",
        GeneratedBatch: "생성된 배치",
        StoredBinLocation: "보관 위치",
        NoManufacturingTransactionsFound: "제조 내역이 없습니다",
        AddManufacture: '제조 세부정보 추가',
        Manufacturing: '제조',
        RawMaterials: '원자재',
        AdditonCosts: '추가 비용',
        RawMaterial: '원자재',
        AdditonCost: '추가 비용',
        TotalCost: '총 비용',
        AddRawMaterial: '다음 원자재 추가',
        AddAdditonCost: '다음 추가 비용 추가',
        AddMore: '더 추가',
        Add: '추가',
        Update: '업데이트',
        Updating: '제출 중...',
        ProductRequired: '상품은 필수입니다',
        QuantityRequired: '수량은 필수입니다',
        ChargeRequired: '비용은 필수입니다',
        EstimatedCostRequired: '예상 비용은 필수입니다',
        PurchasePriceRequired: '구매 가격은 필수입니다',
        SelectCharge: '비용 선택',
        EstimatedCost: '예상 비용',
        SelectProduct: '상품 선택',
        Quantity: '수량',
        ManufactureDetails: '제조 세부정보',
        BuyingPrice: '매입 가격',
        LabourCharge: '노동 비용',
        ElectricityCost: '전기 요금',
        PackagingCharge: '포장 비용',
        LogisticCost: '물류 비용',
        OtherCharges: '기타 비용',
        Save: '세부정보 저장',
        PurchasePrice: '구매 가격',
        Date: '날짜',
        For: '대상',
        PurchaseRate: '구매 단가',
        Scrolltoloadmore: '더 보려면 스크롤...',
        Noproductsfound: '상품을 찾을 수 없습니다',
        ManufacturingQuantity: '제조 수량',
        ManufactureAddedSuccess: '제조 세부정보가 성공적으로 업데이트되었습니다'
    },

    Warehouses: {
        transferOrder: '아이템 전송',
        AddTransferOrder: '아이템 전송 추가',
        NewWarehouse: '새 창고',
        newHead: '여러 창고 관리를 시작하세요!',
        headTwo: '여러 창고의 재고를 원활하게 추적하고 관리하세요',
        EnableWarehouse: '창고 활성화',
        EnableWarehouse2: '창고 사용 설정',
        OrganizationPrimary: '조직 기본 창고',
        Edit: '편집',
        AreEnableWarehouse: '창고를 활성화하시겠습니까?',
        Confirm: '확인',
        Cancel: '취소',
        WarehouseCreatedSuccessfully: '창고가 성공적으로 생성되었습니다',
        MarkAsOP: '조직 기본 창고로 설정',
        MarkAsInAct: '비활성화로 설정',
        MarkAsAct: '활성화로 설정',
        MarkedAsInactive: '창고가 성공적으로 비활성화되었습니다',
        MarkedAsActive: '창고가 성공적으로 활성화되었습니다',
        MarkedAsOP: '창고가 기본 창고로 설정되었습니다',
        WareDeletedSuccess: '창고가 성공적으로 삭제되었습니다',
        SuccessfullyUpdatedWarehouse: '창고가 성공적으로 업데이트되었습니다',
        SuccessfullyCreatedWarehouse: '창고가 성공적으로 생성되었습니다',
        EditWarehouse: '창고 편집',
        AddWarehouse: '창고 추가',
        WarehouseNameIsRequired: '창고 이름은 필수입니다',
        EnterWarehouseName: '창고 이름을 입력하세요',
        EnterEmail: '이메일 주소를 입력하세요',
        EnterPhoneNumber: '전화번호를 입력하세요',
        Location: '위치...',
        name: '창고 이름',
        email: '이메일',
        phoneNumber: '전화번호',
        location: '위치',
        ViewProducts: '제품 보기',
        PageTitle: '창고',
        noWarehouse: "검색과 일치하는 창고가 없습니다"
    },

    Assets: {
        headerTitle: '자산',
        addAssetMessage: '여기서 자산을 추가할 수 있습니다. 직원을 자산에 할당하려면 해당 직원 프로필로 이동하세요.',
        addAsset: '자산 추가',
        editAsset: '자산 편집',
        assetCode: '자산 코드',
        assetName: '자산 이름',
        assetCategory: '자산 카테고리',
        assetType: '자산 유형',
        serialNumber: '시리얼 번호',
        location: '위치',
        condition: '상태',
        selectCondition: '상태 선택',
        fair: '보통',
        good: '양호',
        excellent: '매우 양호',
        poor: '불량',
        notes: '비고',
        submit: '제출',
        submitting: '제출 중',
        noCategory: '카테고리가 없습니다',
        selectCategory: '카테고리 선택',
        addAssetCat: '자산 카테고리 추가',
        addAssetCatName: '자산 카테고리명',
        edit: '편집',
        status: '상태',
        createdAt: '생성일',
        viewAsset: '자산 보기',
        assignAsset: '자산 할당',
        conditionRet: '반환 시 상태',
        searchSelectAssets: '자산 검색/선택',
        assetAssigned: '자산이 성공적으로 할당되었습니다',
        assetReturned: '자산이 성공적으로 반환되었습니다',
        selectAnAsset: '자산을 선택하세요',
        action: '작업',
        noAssetAssigned: '할당된 자산이 없습니다',
        reAssigned: '재할당',
        assignedAssetsList: '할당된 자산 목록',
        viewHistory: "기록 보기",
        history: "자산 내역",
        loadingHistory: "기록 불러오는 중...",
        loadingMore: "더 불러오는 중...",
        dateTime: "날짜 및 시간",
        staff: "직원",
        AssignedBy: "지정자",
        assign: "할당",
        return: "반납",
        unknown: "알 수 없음",
        noHistory: "이 자산에 대한 기록이 없습니다.",
        enterReturnNote: "반납 메모를 입력하세요",
        returnNote: "반납 메모",
        enterAssignNote: "할당 메모를 입력하세요",
        assignNote: "할당 메모",
        AddNAC: "새 자산 카테고리 추가",
        EditNAC: "자산 카테고리 수정",
        others: "기타"
    },
    LedgerTransaction: {
        ledgerDetails: '원장 세부정보',
        productName: '상품명',
        totalQty: '총 수량',
        date: '날짜',
        receivedAmt: '수령 금액',
        paid: '지불 완료',
        discount: '할인',
        balance: '잔액',
        more: '더 보기',
        total: '합계',
        ledgerupdatedsuccessfully: '원장이 성공적으로 업데이트되었습니다',
        ledgeraddedsuccessfully: '원장이 성공적으로 추가되었습니다',
        viewLedger: '원장 보기',
        edit: '편집',
        create: '생성',
        Recieved: '수령됨 [입고]',
        payMode: '결제 방법',
        Refno: '참조 번호'
    },
    ExtraField: {
        attachment: '첨부 파일',
        acceptOnlyImg: '이미지만 허용됩니다',
        addAttribute: '속성 추가',
        acceptImgAndDoc: "이미지 및 문서 허용",
    },
    phoneInvoiceDownload: {
        Variant: "변형",
        Warehouse: "창고",
        Bin: "Bin",
        Batch: "배치",
        Attributes: "속성"
    },
    ImportExcel: {
        ImportStockfromExcel: "Excel에서 재고 가져오기",
        DragDrop: "작성된 Excel 파일을 여기에 드래그 앤 드롭하거나 클릭하여 찾아보기",
        DT: "템플릿 다운로드",
        GB: "뒤로가기",
        Downloading: "다운로드 중...",
        ChangeFile: "파일 변경",
        ReadingExcelfile: "Excel 파일 읽는 중...",
        Processing: "처리 중...",
        submitUpdateStock: "제출 및 재고 업데이트",
        downloadLatestTemplate: "최신 템플릿 다운로드",
        loginRequired: "로그인 필요"
    },
    stockForm: {
        recordPaymentNow: "지금 결제 기록",
        recordPaymentDescCustomer: "고객이 지불한 금액을 입력하세요",
        recordPaymentDescSupplier: "공급업체가 지불한 금액을 입력하세요",
        managePayments: "결제 관리",
        invoice: "청구서",
        challan: "배송장",
        recordPayment: "결제 기록",
        payableAmount: "지불 금액",
        paidAmount: "지불된 금액",
        paymentMethod: "결제 방법",
        paymentDate: "결제 날짜",
        reference: "참조",
        billId: "청구 번호",
        importExcel: "엑셀에서 가져오기",
        noThanks: "아니요",
        checkHistory: "기록 확인",
        wantViewHistory: "기록을 보시겠습니까?",
        enterPayable: "지불 금액 입력",
        enterPaid: "지불된 금액 입력",
        selectPayment: "결제 방법 선택",
        attachment: "첨부 파일",
        note: "메모"
    },
    HistoryEdit: {
        products: "상품",
        add_product: "상품 추가",
        paidAmountInvalidMessage: "지불된 금액은 지불 금액을 초과할 수 없습니다",
        removingText: "이 상품을 제거하면 이 거래 중 변경된 재고가 되돌려집니다.",
        remove: "제거"
    },
    ExcelProduct: {
        uploadFile: "파일 업로드",
        dragDrop: "엑셀 파일을 드래그하거나 클릭하여 업로드하세요.",
        parsingFile: "파일 분석 중",
        fileSelected: "파일 선택됨",
        reviewImportedData: "아래의 가져온 데이터를 검토하세요. 가능한 경우 열이 자동으로 매칭됩니다.",
        changeFile: "파일 변경",
        back: "뒤로",
        invalidFileType: "유효한 엑셀 파일을 업로드하세요 (.xlsx 또는 .xls)",
        parseExcelError: "엑셀 분석 오류:",
        noData: "업로드된 엑셀 파일에 데이터가 없습니다.",
        failedToRead: "엑셀 파일을 읽지 못했습니다. 다시 시도하세요.",
        Nodata: "데이터_없음",
        unableToRead: "파일을 읽을 수 없습니다.",
        buyingMustNumber: "구매 가격은 숫자여야 합니다",
        sellingMustNumber: "판매 가격은 숫자여야 합니다",
        mustBeNumber: "숫자여야 합니다",
        bulkUploadfailed: "대량 업로드 실패",
        importFromExcel: "엑셀에서 가져오기",
        generating: "생성 중...",
        downloadTemplate: "템플릿 다운로드",
        uploading: "업로드 중...",
        done: "완료",
        requiredField: "{field} 필수 항목입니다",
        bulkUpload: "대량 업로드",
        duplicateSku: "중복된 SKU가 발견되었습니다",
        uploadedSuccessfully: "모든 제품이 성공적으로 업로드되었습니다!",
        uploadCompleteIssues: "문제가 발생한 상태로 업로드 완료",
        uploaded_products: "{count}개의 제품이 업로드되었습니다.",
        failed_products: "{count}개 실패했습니다.",
        failed_items: "실패한 항목:"
    },
    Discount: {
        overallDiscount: "전체 할인",
        final: "최종 합계",
        balanceDue: "미지급 잔액",
        tax: "세금"
    },
    ProductForm: {
        barcodeQuantity: "바코드 수량 입력",
        baseUnit: "기본 단위(주 단위)",
        addSecondaryUnit: "보조 단위를 추가하시겠습니까?",
        selectUnit: "단위 선택",
        subUnitDetails: "보조 단위 세부 정보",
        subUnit: "보조 단위",
        selectSubUnit: "보조 단위 선택",
        conversionRate: "환산 비율",
        exampleLogic: "예시 로직:",
        example: "펜을 상자로 판매하는 경우 기본 단위를 상자로 설정하고 환산 비율 50의 보조 단위(개)를 추가하세요. 이는 상자 1개에 50개가 들어 있음을 의미합니다.",
        basePrice: "기본 가격"
    },
    barcode: {
        settings: '바코드 설정',
        labelSize: '라벨 크기',
        customSize: '사용자 지정 크기...',
        widthMm: '너비 (mm)',
        heightMm: '높이 (mm)',
        showPrice: '라벨에 판매 가격 표시',
        noPrices: '이 제품에 대해 구성된 판매 가격이 없습니다.',
        preview: '미리보기',
        generate: '생성',
        label: '라벨',
        singlePage: '단일 페이지',
        downloadOptions: '다운로드 옵션',
        chooseLayout: '바코드 레이아웃 선택',
        allInSinglePage: '모든 바코드를 단일 페이지에 추가합니다.',
        allInA4Grid: '모든 바코드를 한 페이지에',
        allInA4GridSub: '모든 바코드를 A4 그리드에 배치합니다',
        onePerPage: '페이지당 하나',
        onePerPageSub: '각 바코드를 고유한 라벨 페이지에 배치'
    },

    TransferItem: {
        transferItem: "품목 이동",
        Date: "날짜",
        Reason: "사유",
        enterReason: "사유 입력",
        Name: "이름",
        QuantityTransfered: "이동 수량",
        SWarehouse: "출발 창고",
        SelectSWarehouse: "출발 창고 선택",
        DWarehouse: "도착 창고",
        SelectDWarehouse: "도착 창고 선택",
        CreatedBy: "생성자",
        CreatedTime: "생성 시간",
        UpdatedTime: "업데이트 시간",
        NoOrderFound: "주문을 찾을 수 없습니다",
        New: "신규",
        WarehouseItemTransfer: "창고 품목 이동",
        TotalTransfers: "총 이전",
        EnterReason: "사유 입력",
        ItemDetails: "품목 상세",
        CurrentAvailable: "현재 재고",
        TransferQty: "이동 수량",
        SStock: "출발 재고",
        DStock: "도착 재고",
        addDescription: "품목 설명 추가",
        selectVariant: "변형 선택",
        addNewRow: "새 행 추가",
        typeOrSelectItem: "검색하려면 입력하세요",
        scrollToLoadMore: "더 불러오려면 스크롤",
        noProductsFound: "상품을 찾을 수 없습니다",
        selectWarehouse: "창고 선택"
    },
    Sku: {
        searchSelectProduct: "상품 검색 / 선택",
        searchSelectSku: "SKU 검색 / 선택",
        noSkuFound: "SKU를 찾을 수 없습니다"
    },
    HistoryPage: {
        addFilter: "필터 추가",
        filtersActive: "모든 필터 활성화",
        noProducts: "상품 없음",
        download: "다운로드",
        recentlyUpdated: "최근 업데이트됨",
    },
    StockPage: {
        challanNumber: "챌런 번호",
        subTotal: "소계",
        totalTaxes: "합계 및 세금",
        taxInclusive: "세금 포함",
        discountedValue: "할인 금액",
        taxValue: "세금 금액",
        totalAmount: "총 금액",
        close: "닫기",
        addTax: "세금 추가",
        label: "라벨",
        enterLabel: "라벨 입력",
        taxRate: "세율",
        enterTaxRate: "세율 입력",
        selectTaxRate: "세율 선택",
        addNewTax: "새 세율 추가",
        discountProducts: "할인 금액 (제품)",
        taxProducts: "세금 금액 (제품)",
        clickAddPayment: "결제 추가 클릭",
        paidGreaterPayable: "지불 금액은 결제 금액을 초과할 수 없습니다",
        vendorCompulsory: "결제 기록을 위해 공급업체가 필요합니다",
        customerCompulsory: "결제를 기록하려면 고객이 필요합니다",
        updateInvoiceFormat: "송장 형식 업데이트",
        updateChallanFormat: "챌런 형식 업데이트",
        addPrefix: "접두사 추가",
        prefix: "접두사"
    },
    EditHistoryPage: {
        search_by_notes: "메모로 검색",
        alertMessage: "이 변경 사항은 기록에만 저장되며 현재 재고에는 영향을 미치지 않습니다.",
        paymentDetails: "결제 세부 정보",
        units: "단위",
        customLabels: "사용자 정의 라벨",
        value: "값",
        Order_Info: "주문 정보",
        percentage: "백분율",
        Stock_updates_on_submit: "제출 시 재고 업데이트",
        Summary: "요약"
    },
    historyCard: {
        paid: "결제 완료",
        partiallyPaid: "부분 결제",
        billDate: "청구 날짜",
        productDetails: "제품 상세",
        paymentsHistory: "결제 내역",
        updatePayment: "결제 업데이트",
        discounts: "할인",
        inclusive: "(포함)",
        discountOverall: "할인 금액 (전체)",
        dueAmount: "미지급 금액",
        enterPaid: "지불 금액 입력",
        enterReference: "참조 입력",
        enterNote: "메모 입력",
        enterInvoice: "송장 입력",
        enterChallan: "챌런 입력",
        edit: "수정됨"
    },
    printInvoice: {
        billTo: "청구 대상",
        ref: "참조 번호",
        mode: "방식",
        date: "날짜",
        amount: "금액",
        totalPaid: "총 지불액"
    },
    Contact: {
        supplier_required: "재고 입고를 위해 공급업체가 필요합니다",
        customer_required: "재고 출고를 위해 고객이 필요합니다",
        key: "키",
        editHistory: "기록 편집",
        loading: "로딩 중..."
    },
    AW: {
        availablewarehouse: "사용 가능한 창고",
        visibilityManagement: '가시성 관리',
        availablewarehouses: "사용 가능한 창고",
        Active: "활성",
        LWarehouse: "창고 로드 중...",
        NWForthisProduct: "이 제품에 대한 창고를 찾을 수 없습니다.",
        of: "의",
        WarehouseAvailabilty: "창고 가용성",
    },
    Currency: {
        searchCurrency: "통화 검색...",
        addCurrency: "통화 추가",
        addNewCurrency: "새 통화 추가",
        editCurrency: "통화 편집",
        currencySymbol: "통화 기호",
        currencyName: "통화 이름",
        enterCurrencySymbol: "통화 기호 입력",
        enterCurrencyName: "통화 이름 입력"
    },
    NewReportLang: {
        DM: "일일 이동",
        WR: "창고 보고서",
        PDM: "제품 일일 이동",
        TBP: "총 구매 가격",
        TPQ: "총 제품 수량",
        TP: "총 제품",
        CS: "현재 재고",
        IV: "재고 가치",
        DA: "일일 평균",
        TSI: "총 입고",
        TSO: "총 출고",
        TOR: "회전율",
        Tv: "총 가치",
        AST: "활성 SKU 추적",
        UT: "추적된 단위",
        SL: "재고 수준",
        Value: "가치",
        IO: "입고/출고",
        T: "회전",
        unitsD: "단위/일",
        Sort: "정렬",
        Sort_by: "정렬 기준",
        Units_available: "사용 가능한 단위",
        Units_unavailable: "사용 불가 단위",
        Current_assets: "유동 자산",
        Search: "검색",
        available: "사용 가능",
        assigned: "할당됨",
        AYSWD: "정말 삭제하시겠습니까?",
        PTS: "창고가 성공적으로 이전되었습니다",
        AUS: "자산이 성공적으로 업데이트되었습니다",
        ACS: "자산이 성공적으로 생성되었습니다",
        VSP: "판매 가격 보기",
        HUS: "기록이 성공적으로 업데이트되었습니다",
    },
    ReplacementReturn: {
        selectProduct: "상품을 선택해주세요",
        selectReplacementProduct: "최소 하나의 교체 상품을 선택하세요",
        validQuantity: "유효한 반품 수량을 입력해주세요",
        replacedSuccessfully: "상품이 성공적으로 교체되었습니다",
        returnSuccessfully: "상품이 성공적으로 반품되었습니다",
        failedProcess: "처리 실패. 다시 시도해주세요.",
        return: "반품",
        replace: "교체",
        typeSelectProduct: "상품 입력 또는 선택...",
        returnQuantity: "반품 수량",
        enterQuantity: "수량 입력",
        replacementDate: "교체 날짜",
        returnDate: "반품 날짜",
        chooseCustomer: "고객 선택",
        additionalNotes: "추가 메모 입력...",
        replacementProducts: "교체 상품",
        addProducts: "상품 더 추가",
        tapSelect: "사용 가능한 상품에서 선택하려면 탭",
        currently: "현재",
        item: "아이템",
        items: "아이템",
        selected: "선택됨",
        selectedItems: "선택된 아이템",
        hideDetails: "추가 세부정보 숨기기",
        showDetails: "추가 세부정보 보기",
        product: "상품",
        priceLevel: "가격 수준 선택",
        customPrice: "맞춤 가격 입력",
        noReplaceHistory: "교체 내역이 없습니다",
        replaceReturn: "교체 및 반품",
        replaceReturnHistory: "교체 및 반품 내역"
    },
    OtherComponent: {
        mfgHistoryTitle: "제조 이력",
        mfgHistoryDesc: "제조된 재고 제품 추적",
        dailyOperation: "일상 업무",
        freqUsed: "기록을 빠르게 업데이트하기 위한 자주 사용하는 작업",
        manageCategory: "카테고리 관리",
        organizeCaterory: "제품, 비용, 자산 카테고리 정리 및 관리",
        businessRecord: "비즈니스 기록",
        organizeRecord: "비즈니스 기록 정리 및 관리",
        trackHistory: "기록 추적",
        completeTracking: "감사 및 추적을 위한 완전한 기록",
        Verifyinventorycount: "재고 수량 확인",
        Exchangerates: "환율",
        Productiontracking: "생산 추적",
        Fixedassetregister: "고정 자산 등록부",
        Storagelocations: "보관 장소",
        warehouseAvailability: '창고 수준 제품 가용성',
        Logreviewspend: "지출 기록 및 검토",
        Productgroupings: "제품 그룹화",
        Classifyexpenditures: "지출 분류",
        Assetclassification: "자산 분류",
        Manageexchanges: "환율 관리",
        Returnauditlog: "반품 감사 로그",
        Interlocationmoves: "위치 간 이동",
        Manageoperationscategoriesrecordsandhistory: "작업, 카테고리, 기록 및 기록 관리"
    },
    no_permission_dialog: {
        title: '권한 없음',
        historyDescription: "거래 내역을 볼 권한이 없습니다. 관리자에게 문의하세요.",
        replacementHistoryDescription: "교체 및 반품 내역을 볼 권한이 없습니다. 관리자에게 문의하세요.",
        transferHistoryDescription: "창고 이전 내역을 볼 권한이 없습니다. 관리자에게 문의하세요."
    },
    OthersHistory: {
        title: "내역 관리",
        transferHistory: "이전 내역 관리",
        transactionHistory: "거래 내역 관리",
        replacementHistory: "교체 및 반품 내역 관리"
    },
    catalog: {
        allCategories: "All",
        category: "Category",
        purchaseDescription: "비즈니스에서 공유한 제품을 둘러보고 구매하세요.",
        description: "비즈니스에서 공유한 제품을 둘러보세요.",
        productsAvailable: "사용 가능한 제품",
        noImageAvailable: "이미지가 없습니다",
        productDetails: "제품 상세 정보",
        inStock: "재고 있음",
        availableVariants: "사용 가능한 옵션",
        options: "옵션",
        orders: "주문"
        ,
        searchProducts: "상품 검색...",
        noProductsFound: "상품을 찾을 수 없습니다",
        tryDifferentKeyword: "다른 키워드로 검색해 보세요",
        variants: "변형",
        stock: "재고",
        cart: "장바구니",
        products: "상품",
        viewCart: "장바구니 보기",
        backToProducts: "상품으로 돌아가기",
        yourCart: "장바구니",
        clear: "비우기",
        cartEmpty: "장바구니가 비어 있습니다",
        cartEmptyDesc: "카탈로그를 탐색하고 주문할 상품을 추가하세요.",
        browseProducts: "상품 둘러보기",
        selectedItems: "선택한 항목",
        itemInCart: "항목이 장바구니에",
        itemsInCart: "항목이 장바구니에",
        customerDeliveryDetails: "고객 및 배송 정보",
        fullName: "이름",
        enterFullName: "이름을 입력하세요",
        deliveryAddress: "배송 주소",
        addressPlaceholder: "도로명, 건물, 도시, 우편번호...",
        orderNote: "주문 메모 (선택)",
        orderNotePlaceholder: "특별 지시사항 또는 배송 메모...",
        paymentMode: "결제 방식",
        subtotal: "소계",
        items: "항목",
        totalAmount: "총 금액",
        orderOnWhatsApp: "WhatsApp으로 주문 📲",
        orderPlaced: "주문이 성공적으로 완료되었습니다! 🎉",
        orderPlacedDesc: "주문이 기록되었으며 WhatsApp이 열렸습니다.",
        continueShopping: "쇼핑 계속하기 🛍️",
        cartEmptyTitle: "장바구니 비어있음",
        cartEmptyToast: "결제 전에 장바구니에 상품을 추가하세요.",
        incompleteTitle: "불완전한 정보",
        incompleteToast: "주문 전에 모든 필수 항목을 작성하세요.",
        nameRequired: "이름은 필수입니다",
        addressRequired: "배송 주소는 필수입니다",
        catalogUnavailable: "카탈로그 현재 사용 불가",
        catalogUnavailableDesc: "이 카탈로그는 현재 활성화되지 않았습니다.",
        invalidCatalogLink: "유효하지 않은 카탈로그 링크 🚫",
        invalidCatalogDesc: "이 카탈로그 페이지에 필수 정보가 없습니다.",
        missing: "누락",
        catalogSlug: "카탈로그 슬러그",
        goBackHome: "홈으로 돌아가기",
        inventoryManagement: "재고 관리 및 청구 🚀 Simply",
        enter: "입력",
        select: "선택",
        // Catalog Order translations
        catalogOrders: '카탈로그 주문',
        pending: '대기 중',
        converted: '전환됨',
        cancelled: '취소됨',
        totalRevenue: '총 가치',
        totalCatalogOrders: '총 온라인 주문',
        convertToSalesOrder: '판매 주문으로 전환',
        date: '날짜',
        status: '상태',
        action: '작업',
        searchOrders: '고객 또는 전화번호 검색...',
        noMatchingOrders: '일치하는 주문이 없습니다',
        noStatusOrders: '{status} 주문을 찾을 수 없습니다',
        tryDifferentSearch: '다른 고객 이름이나 전화번호로 검색해 보세요.',
        noOrdersWithStatus: '현재 {status} 상태의 주문이 없습니다.',
        noOrdersYet: '아직 카탈로그 주문이 없습니다',
        noOrdersDescription: '온라인 카탈로그에서 접수된 주문이 여기에 표시됩니다.',
        guestCustomer: '비회원 고객',
        item: '항목',
        moreItems: '+{count}개 더',
        viewDetails: '상세 보기',
        viewSalesOrder: '판매 주문 보기',
        cancelOrder: '주문 취소',
        confirmCancelTitle: '카탈로그 주문을 취소하시겠습니까?',
        confirmCancelOrder: '이 주문을 취소하시겠습니까? 이 작업은 되돌릴 수 없습니다.',
        keepOrder: '아니요, 주문 유지',
        confirmCancelAction: '예, 주문 취소',
        orderNotFound: '카탈로그 주문을 찾을 수 없음',
        orderNotFoundDescription: '이 주문을 찾을 수 없거나 볼 수 있는 권한이 없을 수 있습니다.',
        backToCatalogOrders: '카탈로그 주문으로 돌아가기',
        placedOn: '주문일',
        totalItems: '총 항목',
        orderedProducts: '주문 제품',
        itemDetails: '항목 상세',
        quantity: '수량',
        unitPrice: '단가',
        total: '합계',
        variant: '옵션',
        customerInformation: '고객 정보',
        additionalFields: '추가 필드',
        fields: '필드',
    },
    stockNew: {
        Npay: "아직 추가된 제품이 없습니다",
        emptydesc: "카탈로그에서 제품을 선택하고 입고 수량을 입력하여 재고를 기록하세요.",
        tipText: "팁: 엑셀 파일도 업로드할 수 있습니다",
        OT: "주문 총액",
        Collapse: "접기"
    },
    deleteBulk: {
        Bulkoperation: "벌크 작업",
        Applyproducts: "여러 제품에 작업 적용",
        Bulkupload: "벌크 업로드",
        ImportCSVfile: "Excel 또는 CSV 파일로 제품 가져오기",
        or: "또는",
        Bulkdelete: "벌크 삭제",
        Permanentlyallproducts: "모든 제품 영구 삭제",
        IrrText: "벌크 삭제는 되돌릴 수 없습니다. 필요 시 먼저 백업을 내보내세요.",
        SeP: "선택된 제품",
        sP: "제품 선택",
        DA: "모두 삭제",
        DP: "제품 삭제",
        sL: "전체 선택",
        ASDE: "을(를) 제외한 모든 제품을 정말 삭제하시겠습니까?",
        ASDAllP: "모든 제품을 정말 삭제하시겠습니까?",
        ASD: "정말 삭제하시겠습니까",
        products: "제품",
        TACBU: "이 작업은 취소할 수 없습니다.",
        LP: "제품 로드 중...",
        FM: "더 불러오는 중...",
        NPF: "제품을 찾을 수 없습니다.",
        LMP: "더 많은 제품 로드 중..."
    },
    NewVariantModal: {
        Definevariantsassign: "변형 정의 및 수량 할당",
        Nothingallocated: "할당된 것 없음",
        Overallocated: "초과 할당",
        Fullyallocated: "완전 할당",
        Overby: "초과",
        Allvariantsneedaname: "모든 변형에 이름이 필요합니다.",
        Reducequantities: "수량 줄이기.",
        Overallocatedby: "초과 할당됨",
        Quantitiesmustmatchthetotalavailability: "수량은 총 가용성과 일치해야 합니다.",
        Allocatequantitiesacrosswarehouses: "창고별로 수량 할당",
        Notfullydistributed: "완전히 분배되지 않음:",
        remaining: "남음",
        Qty: "수량",
        Inactive: "비활성",
        left: "남음"
    },
    ProductFormNew: {
        BasicInfo: "기본 정보",
        ProductImage: "제품 이미지",
        Images: "이미지",
        Pricing: "가격",
        Everypriceneedsbothalabelandanamount: "모든 가격에는 라벨과 금액이 모두 필요합니다",
        AddalabellikeWholesaleorRetailtoidentifythisprice: '"도매" 또는 "소매" 같은 라벨을 추가하여 이 가격을 식별하세요',
        AddMultiplePrice: "여러 가격 추가",
        NoPhotosLetAiFind: "사진이 없나요? AI가 제품 이미지를 찾도록 하세요",
        AddProductImagesTitle: "제품 이미지 추가",
        ChooseHowToAddPhotos: "이 제품에 사진을 추가하는 방법을 선택하세요:",
        SearchWithAi: "AI로 검색",
        SearchWithAiDesc: "AI를 사용하여 제품 이미지를 자동으로 검색 및 선택",
        FilesFileExplorer: "파일 (파일 탐색기)",
        FilesFileExplorerDesc: "컴퓨터에서 직접 이미지 선택",
        AiProductImageFinder: "AI 제품 이미지 탐색기",
        AiProductImageFinderDesc: "제품의 이미지 검색 및 선택",
        TypeProductNamePlaceholder: "제품 이름 입력...",
        SearchForYourProduct: "제품 검색",
        SearchForYourProductHint: `브랜드 또는 제품 이름을 입력해보세요 (예: "커클랜드 미녹시딜")`,
        ImagesSelected: "개 이미지 선택됨",
        AddSelected: "선택 항목 추가"
    },
    AttributeNewCustom: {
        Defineanewcustomfield: "새 사용자 정의 필드 정의",
        AttributeName: "속성 이름",
        DataType: "데이터 유형",
        Noattributesfound: "속성을 찾을 수 없습니다",
        ManageAttributes: "속성 관리",
        Editordeleteexistingattributes: "기존 속성 편집 또는 삭제",
        UpdateAttribute: "속성 업데이트",
        Saving: "저장 중..."
    },
    NewExpenses: {
        Noexpensesyet: "아직 지출이 없습니다",
        Addyourfirstexpensetostarttrackingyourspending: "첫 번째 지출을 추가하여 지출 추적을 시작하세요.",
        TOTALEXPENSES: "총 지출",
        ENTRIES: "항목",
        BYCATEGORY: "카테고리별",
        Nocategoriestodisplay: "표시할 카테고리가 없습니다",
        DateanfTime: "날짜 및 시간"
    },
    PurchaseSales: {
        CancelOrder: "주문 취소",
        ReopenOrder: "주문 재개",
        Reopen: "재개",
        ConfirmCancelOrder: "이 주문을 취소하시겠습니까?",
        ConfirmReopenOrder: "이 주문을 재개하시겠습니까?",
        OrderCancelledSuccessfully: "주문이 성공적으로 취소되었습니다.",
        OrderReopenedSuccessfully: "주문이 성공적으로 재개되었습니다.",
        CancelledBy: "취소자",
        Cancelled: "취소됨",
        ConvertPriceBasedOnUnitConversion: "단위 변환에 따라 가격 변환",
        MarkPaymentAsPending: "결제를 보류 중으로 표시",
        PendingReceivableDesc: "미수금으로 기록됨. 수금 시 결제를 기록하세요.",
        PendingPayableDesc: "미지급금으로 기록됨. 지급 시 결제를 기록하세요.",
        SelectCustomerFirst: "먼저 고객을 선택하세요",
        SelectSupplierFirst: "먼저 공급업체를 선택하세요",
        SelectItemsFirst: "먼저 하나 이상의 품목을 선택하세요",
        PaymentMarkedPendingDesc: "결제가 보류 중으로 표시되었습니다. 지금 결제를 기록하려면 '결제를 보류 중으로 표시'를 선택 해제하세요.",
        SelectCustomerAndItemFirst: "먼저 고객과 하나 이상의 항목을 선택하세요",
        SelectSupplierAndItemFirst: "먼저 공급업체와 하나 이상의 항목을 선택하세요",
        SelectCustomerProductFirst: "먼저 고객과 제품을 선택하세요",
        SelectSupplierProductFirst: "먼저 공급업체와 제품을 선택하세요",
        Receivables: "미수금",
        Payables: "미지급금",
        AccessDenied: "접근 거부됨",
        YouDonthaeP: "이 페이지에 접근할 권한이 없습니다. 실수라고 생각되면 관리자에게 문의하세요.",
        purchase: "구매",
        sales: "판매",
        Areyousureyouwantto: "정말로",
        Thisactionwillupdateitsstatus: "이 작업은 상태를 업데이트합니다.",
        ReasonOPtional: "사유 (선택)",
        Enterareasonfor: "사유 입력",
        optionalDot: "(선택)...",
        Reject: "거부",
        ConfirmOrder: "주문 확정",
        RejectOrder: "주문 거부",
        Previous: "이전",
        First: "처음",
        Order: "주문",
        Items: "품목",
        Memo: "메모",
        SelectDateRange: "날짜 범위 선택",
        List: "목록",
        Board: "보드",
        View: "보기",
        CreateSalesOrder: "판매 주문 생성",
        CreatePurchaseOrder: "구매 주문 생성",
        successfully: "성공",
        ManageAttachments: "첨부파일 관리",
        Stockoutitemsimmediatelyaftersaving: "저장 후 즉시 품목 출고",
        Stockinitemsimmediatelyaftersavingthisorder: "이 주문 저장 후 즉시 품목 입고",
        ViewAttachments: "첨부파일 보기",
        MemoAttachments: "메모 및 첨부파일",
        ReceivedDate: "수령일",
        ShippedDate: "출고일",
        OrderDate: "주문일",
        OrderDetails: "주문 상세",
        Subtotal: "소계",
        OrderSummary: "주문 요약",
        AddItem: "품목 추가",
        NewSalesOrder: "신규 판매 주문",
        NewPurchaseOrder: "신규 구매 주문",
        Createandmanageyour: "생성 및 관리",
        orders: "당신의 주문",
        Removeitem: "품목 제거",
        UnitPrice: "단가",
        PurchaseOrder: "구매 주문",
        SalesOrder: "판매 주문",
        PurchaseInvoice: "구매 송장",
        SalesInvoice: "판매 송장",
        PurchaseOrdernotfound: "구매 주문 없음",
        Approve: "승인",
        MarkasShipped: "출고 완료 표시",
        MarkasReceived: "수령 완료 표시",
        Marking: "표시 중...",
        PartiallyShip: "부분 출고",
        PartiallyReceive: "부분 수령",
        Deleting: "삭제 중...",
        Transaction: "거래",
        Details: "상세",
        Item: "품목",
        Received: "수령",
        Shipped: "출고",
        Ordered: "주문",
        units: "단위",
        Overalldiscount: "전체 할인",
        Transactions: "거래 내역",
        Notransactionsfound: "거래 내역 없음",
        OrderedQty: "주문 수량",
        Totalqty: "총 수량",
        StockingOut: "출고 중...",
        StockingIn: "입고 중...",
        thiorderUpdateStuau: "이 주문? 이 작업은 상태를 업데이트합니다.",
        TransactionDetails: "거래 상세",
        Fetchingtransactiondetails: "거래 상세 가져오는 중...",
        Nodetailsfoundforthistransaction: "이 거래에 대한 상세 정보 없음.",
        TotalBreakDown: "총 내역",
        ChangeAmount: "거스름돈",
        Attachments: "첨부파일",
        PoNumber: "PO 번호",
        SoNumber: "SO 번호",
        partner: "파트너",
        EditPurchase: "구매 수정",
        EditSales: "판매 수정",
        PurchaseOrderDetails: "구매 주문 상세",
        SalesOrderDetails: "판매 주문 상세",
        OrderType: "주문 유형",
        SelectOrderType: "주문 유형 선택",
        OrderTypePrepaid: "선불",
        OrderTypeCOD: "착불 (COD)",
        OrderTypePayLater: "나중에 결제",
        OrderTypePartialPayment: "분할 납부",
        OrderTypeSubscription: "구독",
        viewAvailabilty: '예약 가능 여부 보기',
        NotReceived: "미수령",
        NotShipped: "미출고",
        PartiallyReceived: "부분 수령됨",
        PartiallyShipped: "부분 출고됨",
    },
    PriceReference: {
        HighPrice: "높은 가격",
        LowPrice: "낮은 가격",
        LastPrice: "최근 가격",
        LastPurchasePrice: "최근 구매 가격",
        Nopricerecordsfound: "가격 기록을 찾을 수 없습니다",
        BuyingPriceReference: "구매 가격 참조",
        SellingPriceReference: "판매 가격 참조",
        Viewstockinpricesfortheselectedvendorandproduct: "선택한 공급업체 및 제품의 입고 가격 보기",
        Viewstockoutpricesfortheselectedcustomerandproduct: "선택한 고객 및 제품의 출고 가격 보기"
    },
    SubscriptionLocale: {
        premiumPlan: "프리미엄 플랜",
        heading: "비즈니스 결정을 내리세요",
        headingHighlight: "데이터 기반으로",
        subtitle: "비즈니스 분석의 모든 힘을 해제하세요 — 제한 없음, 타협 없음.",
        choosePlan: "플랜 선택하기",
        monthly: "월간",
        annual: "연간",
        oneTime: "일회 (월간)",
        perMonth: "월",
        perYear: "년",
        bestValue: "최고의 가치",
        continueWith: "계속하기",
        perMonthShort: "월",
        perYearShort: "년",
        troubleWithSubscription: "구독에 문제가 있나요?",
        contactUs: "문의하기",
        paymentNotReady: "결제가 준비되지 않았습니다",
        checkoutError: "결제 오류",
        pricePreviewError: "가격 미리보기 오류",
        subNotAvailable: "구독을 사용할 수 없습니다",
        subNotAvailableDesc: "현재 귀하의 국가에서는 웹 구독을 이용할 수 없습니다. 모바일 앱을 통해 구독하거나 도움이 필요하면 문의해 주세요."
    },
    SubscriptionLocale2: {
        GoPro: "프로로 전환",
        Makesmarterdecisionsbackedbyrealbusinessdata: "실제 비즈니스 데이터를 기반으로 더 스마트한 결정을 내리세요",
        ExploreProPlans: "프로 플랜 살펴보기"
    },
    emptyWarehouseState: {
        tips: [
            "다른 물리적 위치에 여러 창고를 가질 수 있습니다",
            "각 제품은 창고별로 독립적으로 재고를 추적합니다",
            '"창고 이동" 기능을 사용하여 위치 간 재고를 이동하세요'
        ],
        NoWarehousesConfigured: "설정된 창고가 없습니다",
        desc: "먼저 창고를 추가하세요(여러 개가 있는 경우), 그 다음 제품을 추가하고 재고 이동을 기록하세요.",
        WarehouseSetupTips: "창고 설정 팁",
        Noproductselected: "선택된 제품 없음",
        Selectaproductfromthelefttoviewlowstockdetails: "재고 부족 상세를 보려면 왼쪽에서 제품을 선택하세요.",
        Chooseaproductfromthelist: "목록에서 제품 선택",
        SelectProduct: "제품 선택",
        SetQuantity: "수량 설정",
        Showing: "표시 중",
        products: "제품",
        Continue: "계속",
        SaveSafetyStock: "안전 재고 저장",
        SafetyStockSaved: "안전 재고가 저장되었습니다!",
        hasbeensetto: "로 설정되었습니다",
        AddAnother: "추가하기",
        Chooseaproduct: "제품 선택",
        Step: "단계",
        of: "중",
        Setsafetyquantity: "안전 수량 설정",
        Complete: "완료",
        SafetyStockQuantity: "안전 재고 수량",
        Minimumunitsdropsbelowthisnumber: "항상 재고에 유지해야 하는 최소 단위 수. 재고가 이 숫자 아래로 떨어지면 알림이 발생합니다.",
        NewSafetyStock: "새 안전 재고",
        SafetyNow: "현재 안전 재고",
        SettingTo: "설정 중",
        Change: "변경",
        sell: "판매",
        cost: "원가",
        BulUD: "대량 업로드/삭제"
    },
    SimplyLoginUI: {
        sslEncryption: "256-bit SSL 암호화",
        dataPrivate: "당신의 데이터는 100% 비공개입니다",
        worksOnDevices: "Android & iPhone에서 작동",
        realTimeSync: "모든 기기에서 실시간 동기화",
        cloudBackup: "자동 클라우드 백업",
        availableOn: "웹, Android, iOS에서 사용 가능",
        tagline: "당신의 재고,",
        taglineEm: "아름답게 간단합니다.",
        subtitle: "재고 관리, 판매 추적, 비즈니스 운영을 위해 로그인하세요 — 모든 것이 한 곳에.",
        feature1Title: "실시간 재고 추적",
        feature1Desc: "각 창고에 정확히 무엇이 있는지 항상 최신으로 확인하세요.",
        feature2Title: "판매 및 구매 주문",
        feature2Desc: "송장 생성, 공급업체 관리, 모든 거래 추적.",
        feature3Title: "스마트 리포트",
        feature3Desc: "재무, 재고, 일일 움직임 리포트를 한눈에.",
        feature4Title: "모든 기기에서 실시간 동기화",
        feature4Desc: "휴대폰에서 변경한 내용이 웹에 즉시 반영됩니다 — 반대도 마찬가지.",
        rating1: "평점",
        rating2: "4.9/5",
        rating3: "10,000개 도매 기업의 평가",
        brandName: "Simply",
        greeting: "다시 오신 것을 환영합니다! 👋",
        noPasswordNeeded: "재고에 접근하려면 로그인하세요 — Android, iPhone, 웹 모두 동기화됩니다.",
        badge1: "재고 관리",
        badge2: "판매 추적",
        badge3: "리포트",
        trustEncryptedTitle: "암호화됨",
        trustEncryptedSub: "256-bit SSL",
        trustPrivateTitle: "비공개",
        trustPrivateSub: "당신의 데이터만",
        trustBackedTitle: "백업됨",
        trustBackedSub: "매일 자동",
        availableOnLabel: "사용 가능",
        platformAndroid: "Android",
        platformIphone: "iPhone",
        platformWeb: "웹",
        syncBadge: "모든 기기가 실시간으로 즉시 동기화됩니다",
        securityNote: "100% 안전합니다.",
        securityDesc: "은행 수준의 암호화가 모든 데이터를 보호합니다. 우리는 이름과 이메일만 읽습니다 — 그 외에는 절대 아무것도.",
        signingIn: "로그인 중…",
        termsPrefix: "로그인함으로써 Simply의",
        privacyPolicy: "개인정보 처리방침",
        and: "및",
        termsOfService: "이용약관",
        google: "Google로 로그인"
    },
    BatchLocal: {
        BatchName: "배치 이름",
        EnterBatchName: "배치 이름 입력",
        EnterNotes: "메모 입력",
        ExpiredDate: "유통기한",
        Selectexpireddate: "유통기한 선택",
        BatchStatus: "배치 상태",
        CreatedDate: "생성일",
        Areyousureyouwanttodeletethisbatch: "이 배치를 정말 삭제하시겠습니까?",
        Youhavencreatedanybatchforthisproduct: "이 제품에 대한 배치를 아직 생성하지 않았습니다.",
        Createyourfirstbatchtostarttrackingtockbylotexpiry: "첫 번째 배치를 만들어 로트 및 유통기한으로 재고를 추적하세요.",
        Nobatchesyet: "아직 배치가 없습니다",
        Whatisbatchmanagement: "배치 관리가 무엇인가요?",
        Howithelpsyourbusiness: "비즈니스에 어떻게 도움이 되나요",
        Trackbylotnumber: "로트 번호로 추적",
        Trackbylotnumberdesc: "제조사 배치별로 재고를 그룹화하여 각 유닛이 어떤 로트에서 왔는지 항상 알 수 있습니다.",
        Expirydatecontrol: "유통기한 관리",
        Expirydatecontroldesc: "재고가 만료되기 전에 알림을 받으세요. 오래된 배치를 먼저 판매하여 폐기물을 자동으로 줄입니다.",
        Fulltraceability: "완전한 추적성",
        Fulltraceabilitydesc: "모든 거래에서 정확히 어떤 배치가 사용되었는지 확인할 수 있습니다 — 감사와 리콜에 매우 유용합니다.",
        Supplierwisestock: "공급업체별 재고",
        Supplierwisestockdesc: "같은 제품이라도 서로 다른 공급업체의 재고를 분리합니다. 배치별로 품질을 비교하세요.",
        Createyourfirstbatchbutton: "첫 번째 배치 만들기",
        Nomatchesfound: "일치하는 항목 없음",
        NomatchesfounddescBefore: "",
        NomatchesfounddescAfter: "와 일치하는 배치를 찾을 수 없습니다.",
        Clearsearch: "검색 지우기",
        Nohistoryfoundthisbatch: "이 배치에 대한 기록이 없습니다",
        ComprehensiveDetails: "상세 정보",
        History: "기록",
        InBatch: "배치 내",
        Noproductfoundinthisbatch: "이 배치에 제품이 없습니다",
        SelectBatch: "배치 선택",
        available: "사용 가능",
        Searchbatches: "배치 검색...",
        Expires: "만료",
        Nobatchesfound: "배치가 없습니다",
        ManageBatches: "배치 관리",
        Batchmanagement: "배치 관리",
        Trackstockexpiry: "배치 및 유통기한으로 재고 추적",
        Turnoffbatchmanagement: "배치 관리를 끄시겠습니까?",
        Yourgsafe: "기존 배치 데이터는 안전하게 유지됩니다.",
        Reenableanytimefrom: "언제든지",
        Otherstab: "기타 탭에서",
        AddBatch: "배치 추가",
        Total: "총계",
        AssignProduct: "제품 할당",
        EditProductAssignment: "제품 할당 편집",
        AssignProducttoBatch: "제품을 배치에 할당",
        Updateproductconfiguration: "제품 구성 업데이트",
        Step1of2: "1단계 중 1",
        Step2of2: "2단계 중 2",
        Selectvariantwarehouse: "변형 및 창고 선택",
        SelectedProduct: "선택된 제품",
        AssignQuantity: "수량 할당",
        BatchInfo: "배치 정보",
        Wecouldnthisproductidentifier: "이 제품 식별자와 연결된 배치를 찾을 수 없습니다.",
        NoActiveBatches: "활성 배치 없음",
        Endofresults: "결과 종료",
        Expiry: "유통기한",
        BatchManagementDescription: "배치 번호 및 유통기한별로 재고를 추적합니다. 모든 출고 시 정확한 LIFO / FEFO 순서를 보장하여 수동 피킹이 필요 없습니다.",
        Expiryalerts: "유통기한 알림",
        Autonotifications: "자동 알림",
        LIFOsorting: "LIFO / FEFO 정렬",
        Smartstockflow: "스마트 재고 흐름",
        Perout: "배치별 출고",
        Precisiontracking: "정밀 추적",
        NeedsReview: "검토 필요",
        Pending: "대기 중",
        Rejected: "거부됨",
        Approved: "승인됨",
        WaitingForApproval: "승인 대기 중",
        WaitingForApprovalDesc: "소유자가 곧 이 배치를 검토하고 승인할 것입니다.",
        BatchRejected: "배치 거부됨",
        BatchRejectedDesc: "소유자가 이 배치를 거부했습니다.",
        Reason: "사유",
        Approve: "승인",
        Reject: "거부",
        ConfirmApproveTitle: "배치 승인",
        ConfirmRejectTitle: "배치 거부",
        ConfirmApprovalAction: "이 배치를 {action}하시겠습니까? 이 작업은 상태를 업데이트합니다.",
        ReasonOptional: "사유 (선택)",
        EnterReasonPlaceholder: "{action}에 대한 사유를 입력하세요 (선택)",
        Processing: "처리 중...",
        BatchActivatedSuccess: "배치가 성공적으로 활성화되었습니다",
        BatchDeactivatedSuccess: "배치가 성공적으로 비활성화되었습니다",
        BatchDeletedSuccess: "배치가 성공적으로 삭제되었습니다",
        BatchApprovedSuccess: "배치가 성공적으로 승인되었습니다",
        BatchRejectedSuccess: "배치가 성공적으로 거부되었습니다",
        SearchByBatchName: "배치 이름으로 검색...",
        YesTurnOff: "예, 끄기",
        KeepItOn: "켜두기"
    },
    CategoryNewL: {
        TotalCategories: "총 카테고리",
        lastaddedcategory: "마지막으로 추가된 카테고리",
        acrossalltypes: "모든 유형에서",
        MostRecent: "최근",
        YesD: "네, 삭제",
        AllAssociated: "연결된 모든 제품이 영향을 받을 수 있습니다"
    },
    OverDas: {
        movestockbetweenlocations: "재고 이동",
        no_activity_yet: "아직 활동이 없습니다",
        no_activity_sub: "판매, 구매, 재고 이동 및 반품이 실시간으로 여기에 표시됩니다.",
        make_first_sale: "첫 판매 하기",
        add_stock: "재고 추가",
        all_stock_healthy: "모든 재고 수준이 양호합니다",
        all_stock_healthy_sub: "재고 부족 품목이 없습니다. 상품에 최소 기준을 설정하면 여기서 알림을 받을 수 있습니다.",
        set_stock_thresholds: "재고 기준 설정",
        no_warehouses_setup: "설정된 창고가 없습니다",
        no_warehouses_setup_sub: "재고가 어디에 보관되어 있는지 추적하고 위치를 관리하려면 창고를 추가하세요.",
        add_first_warehouse: "첫 번째 창고 추가",
        Customer: "고객",
        PurchasevsSales: "구매 vs 판매",
        Financialperformancechart: "재무 성과 차트",
        QuickActions: "빠른 작업",
        Frequentlyused: "자주 사용하는 기능",
        Addinventory: "재고 추가",
        Dispatchitems: "상품 출고",
        Addorder: "주문 추가",
        Newitem: "새 상품",
        Inventoryaccess: "재고 접근",
        Itemsneedingreorder: "재주문이 필요한 상품",
        Latesttransactions: "최근 거래",
        Operationalsummary: "운영 요약",
        ViewAll: "모두 보기",
        Manage: "관리",
        RecentActivity: "최근 활동",
        LowStockAlerts: "재고 부족 알림",
        Primary: "기본",
        TotalWarehouses: "총 창고 수"
    },
    SerialLocal: {
        ShowOrHideFields: "필드 표시 또는 숨기기",
        ShowOrHideFieldsDesc: "인쇄된 송장에 포함하거나 제거하려면 아래 항목을 탭하세요. 변경 사항은 즉시 적용됩니다.",
        Manufacturesettings: "제조 설정",
        Showbuyingprice: "구매 가격 / 제품 비용",
        Showadditionalcost: "추가 비용",
        Costbreakdown: "비용 내역",
        Unitcost: "단위 비용",
        Rawmaterialstotal: "원자재 총액",
        Confirmentry: "입력 확인",
        SaveSerials: "시리얼 번호 저장",
        SerialNumber: "시리얼 번호",
        selected: "선택됨",
        added: "추가됨",
        Serialnumbers: "시리얼 번호",
        ResetAll: "모두 초기화",
        Wecouldnfindthis: "이 제품에 사용 가능한 시리얼 번호를 찾을 수 없습니다.",
        Nounitsfound: "유닛을 찾을 수 없습니다",
        Searchingserialnumbers: "시리얼 번호 검색 중...",
        Scanorenterstock: "새 재고의 시리얼을 스캔하거나 입력하세요",
        Whataserialnumber: "시리얼 번호란 무엇인가요?",
        Auniqueidentifieryourinventorylifecycle: "단위당 고유 식별자 — 재고 수명 주기 내내 각 개별 품목을 추적할 수 있습니다.",
        Trackedstockout: "추적된 출고",
        Chooseexactlyselected: "나가는 정확한 시리얼 번호를 선택하세요. 이 제품에 입고된 시리얼만 표시됩니다 — 선택하면 수량이 잠깁니다 ",
        SelectSerialstoout: " - 출고할 시리얼 선택",
        Thisinvoicegeneratedusingwwwsimplstockco: "이 송장은 www.simplstock.co를 사용하여 생성되었습니다",
        AuthorizedSignature: "승인된 서명",
        Invoicesettings: "송장 설정",
        Draw: "그리기",
        Taptoselectordeselectitems: "항목을 선택하거나 해제하려면 탭하세요",
        Thissignaturewillbeadded: "이 서명은 인쇄된 송장 하단에 추가됩니다.",
        SignatureOptions: "서명 옵션",
        Upload: "업로드",
        DrawSignature: "서명 그리기",
        UploadSignature: "서명 업로드",
        Clear: "지우기",
        ShowStaffName: "직원 이름",
        ShowSKU: "SKU",
        ShowBusinessName: "사업체명",
        ShowProductName: "제품명",
        ShowBusinessPhoneNumber: "비즈니스 전화번호",
        ShowBusinessEmail: "비즈니스 이메일",
        ShowBusinessAddress: "비즈니스 주소",
        ShowProductImage: "제품 이미지",
        ShowPaymentDetails: "결제 세부 정보",
        ShowCategory: "카테고리",
        ShowVariant: "변형",
        ShowWarehouse: "창고",
        ShowAttributes: "속성",
        ShowQuantity: "수량",
        ShowDiscount: "할인",
        ShowTax: "세금",
        ShowPrice: "가격",
        ShowTotalPrice: "제품 총 가격",
        ShowExpenses: "비용",
        ShowSignature: "서명",
        ShowNote: "메모",
        ShowSerialNumber: "시리얼 번호",
        Invoicesettingsapplied: "송장 설정이 적용되었습니다. 변경 사항은 송장을 확인하세요.",
        EnterSerialNumber: "시리얼 번호 입력",
        showAttachment: "첨부파일 보기"
    },
    FewLocal: {
        SelectBin: "빈 선택",
        Live: "실시간",
        Monitorinventorystocklevels: "재고, 이동 및 재고 수준 모니터링",
        StockControlCentre: "재고 관리 센터",
        Nochartdataavailable: "차트 데이터가 없습니다",
        Disabled: "비활성화됨",
        Enabled: "활성화됨"
    },
    Bin: {
        Bin: "빈",
        Add: "추가",
        NoBinsAddedYet: "아직 추가된 빈이 없습니다",
        BinLocationsHelp: "빈 위치는 이 창고 내부의 정확한 위치로 재고를 추적하는 데 도움이 됩니다 — 더 이상 검색할 필요가 없습니다.",
        NameThemByPosition: "위치별로 이름 지정:",
        AddBinLocation: "빈 위치 추가",
        BinLocations: "빈 위치",
        BinNameRequired: "빈 이름은 필수입니다",
        EditBin: "빈 편집",
        AddBin: "빈 추가",
        EnterBinName: "빈 이름",
        EnterBinNamePlaceholder: "빈 이름 입력",
        BinStatus: "빈 상태",
        BinNotes: "메모",
        EnterBinNotesPlaceholder: "메모를 추가하세요...",
        ViewInventory: "재고 보기",
        Inventory: "재고",
        TrymatchingadifferentSKUname: "다른 SKU 또는 이름으로 시도해 보세요.",
        Thisbinlocationcurrentlyempty: "이 빈 위치는 현재 비어 있습니다.",
        Loadingbins: "빈 로딩 중...",
        bins: "빈",
        ManageBin: "빈 관리",
        Print: "인쇄",
        SBin: "출발 Bin",
        DBin: "도착 Bin"
    },
    WarehouseExcel: {
        title: "창고 및 빈 위치 업로드",
        description: "Excel 파일을 사용하여 창고와 빈 위치를 대량으로 생성하려면 아래 단계를 따르세요.",
        bulkUploadGuide: "대량 업로드 가이드",
        step1: "단계 1",
        downloadTemplate: "Excel 템플릿 다운로드",
        downloadTemplateDesc: "필요한 모든 열 헤더가 미리 구성된 공식 템플릿을 다운로드하세요. 열 이름을 변경하거나 삭제하지 마세요.",
        downloadTemplateBtn: "템플릿 다운로드",
        step2: "단계 2",
        fillExcelFile: "Excel 파일 작성",
        fillExcelDesc: "각 행은 하나의 창고를 나타냅니다. 모든 열을 작성하세요 — 빈 위치는 <code>Bin Names</code> 열에 쉼표로 구분하여 입력하세요.",
        step3: "단계 3",
        thingsToKeepInMind: "유의사항",
        rulesDesc: "업로드하기 전에 파일이 다음 규칙을 준수하는지 확인하세요.",
        step4: "단계 4",
        uploadYourFile: "파일 업로드",
        uploadDesc: "작성 완료 후 아래에서 파일을 업로드하세요. 시스템이 자동으로 모든 창고와 빈 위치를 생성합니다.",
        rules: ["창고당 한 행만", "빈 이름은 한 셀에 쉼표로 구분", "열 헤더 이름 변경 금지", "같은 창고 내 중복 빈 이름은 건너뜀", "국가 코드 포함 전화번호", ".xlsx 또는 .xls 파일만 허용"],
        dropFileHere: "Excel 파일을 여기에 드롭하세요",
        supports: ".xlsx 및 .xls 지원 — 최대 10 MB",
        chooseFileUpload: "파일 선택 & 업로드",
        parsing: "파일 분석 중...",
        invalidFileType: "잘못된 파일 형식입니다. Excel 파일을 업로드하세요.",
        noData: "Excel에서 데이터를 찾을 수 없습니다",
        failedToRead: "Excel 파일을 읽지 못했습니다",
        unableToRead: "파일을 읽을 수 없습니다.",
        reviewTitle: "창고 데이터 검토",
        reviewSubtitle: "비즈니스에 가져오기 전 최종 확인입니다.",
        changeFile: "파일 변경",
        rowsFound: "행 발견",
        cancel: "취소",
        finalizeImport: "완료하고 가져오기",
        importing: "가져오는 중...",
        success: "성공",
        allWarehouseUploadedSuccess: "모든 창고가 성공적으로 업로드되었습니다",
        failed: "실패",
        bulkUploadFailed: "대량 업로드 실패",
        error: "오류",
        binNamesNote: "<strong>Bin Names</strong> 열에 창고별 모든 빈 위치를 한 셀에 쉼표로 구분하여 입력하세요 — 예: A1, A2, B1, RACK-01.",
        headers: { warehouseName: "창고 이름", email: "이메일", phoneNumber: "전화번호", location: "위치", binNames: "빈 이름" }
    },
    VariantTemplate: {
        VariantTemplates: "변형 템플릿",
        Managereusablevariantpatterns: "재사용 가능한 변형 패턴 관리",
        BinTransferHistory: "빈 이동 기록",
        Trackmovementsacrossbins: "빈 간 이동 추적",
        SerialNumberHistory: "시리얼 번호 기록",
        Trackproductserialnumberactivity: "제품 시리얼 번호 활동 추적",
        Period: "기간",
        Nohistoryfound: "기록이 없습니다",
        Searchserialnumbers: "시리얼 번호 검색...",
        SerialNumbersHistory: "시리얼 번호 기록",
        Serialnumberhistoryglance: "시리얼 번호 기록 한눈에 보기.",
        Noserialnumbersfound: "시리얼 번호를 찾을 수 없습니다",
        Noactivityhistoryfound: "활동 기록이 없습니다",
        Statussetto: "상태를 다음으로 설정",
        Timeline: "타임라인",
        Managereusableproductvariantpatterns: "재사용 가능한 제품 변형 패턴 관리.",
        DeleteTemplate: "템플릿 삭제",
        Areyousureyouwanttemplate: "이 템플릿을 삭제하시겠습니까?",
        CreateNewTemplate: "새 템플릿 만들기",
        CreateTemplate: "템플릿 만들기",
        EditTemplate: "템플릿 편집",
        UnlimitedTemplates: "무제한 템플릿",
        CreateAsManyTemplates: "필요한 만큼 템플릿을 만드세요 — 의류, 신발, 전자제품 등.",
        PickWhileAddingProduct: "제품 추가 시 선택",
        OpenTemplateLibrary: "템플릿 라이브러리를 열고 몇 초 만에 변형 이름을 선택하세요.",
        MixFromMultipleTemplates: "여러 템플릿에서 조합",
        SelectFromMultipleTemplates: "하나의 제품에 여러 템플릿에서 변형 이름을 선택 — 완전 유연.",
        EditAnytime: "언제든지 편집",
        RenameTemplatesAnytime: "카탈로그가 변경될 때 템플릿 이름 변경, 변형 이름 추가/제거.",
        StayConsistent: "일관성 유지",
        SameVariantNamesAcrossAll: "모든 제품에 동일한 변형 이름. 오타, 중복, 추측 없음.",
        BuildOnceUseEverywhere: "한 번 만들고, 어디서나 사용",
        StopReEnteringVariantNames: "매번 같은 변형 이름을 반복 입력하지 마세요. 템플릿을 만들고 이름을 할당한 후 즉시 재사용하세요.",
        Updateexistingvariantcombinations: "기존 변형 조합 업데이트",
        Definenewvariantcombinations: "새 변형 조합 정의",
        TemplateName: "템플릿 이름",
        AddVariantOptions: "변형 옵션 추가",
        SmallMedium: "예: Small, Medium...",
        VariantsList: "변형 목록",
        Nooptionsaddedyet: "아직 옵션이 추가되지 않았습니다",
        SaveTemplate: "템플릿 저장",
        egSizesColorsetc: "예: 티셔츠 사이즈, 색상 등",
        Pleaseentertemplatename: "템플릿 이름을 입력해주세요",
        Pleaseaddatleastonevariantoption: "최소 하나의 변형 옵션을 추가해주세요",
        Templateupdatedsuccessfully: "템플릿이 성공적으로 업데이트되었습니다",
        Templatecreatedsuccessfully: "템플릿이 성공적으로 생성되었습니다",
        Failedtosavetemplate: "템플릿 저장 실패",
        Transfer: "이동",
        Editassignment: "할당 편집",
        Updateproductdetailsinbin: "빈의 제품 정보 업데이트",
        Editinginbin: "빈에서 편집 중",
        ConfirmUpdate: "업데이트 확인",
        ConfirmAssign: "할당 확인",
        Assignanotherproduct: "다른 제품 할당",
        TransferBin: "빈 이동",
        SourceBin: "출발 빈",
        DestinationBin: "도착 빈",
        SelectSourceBin: "출발 빈 선택",
        SelectDestinationBin: "도착 빈 선택",
        Unit: "단위",
        ManageVariant: "변형 관리",
        CreateSKUvariationsyourproduct: "제품의 SKU 변형 생성",
        Assigningvariationsto: "변형 할당 중",
        Novariantsaddedyet: "아직 변형이 추가되지 않았습니다",
        AddedVariants: "추가된 변형",
        AddVariantsfromTemplate: "템플릿에서 변형 추가",
        Pickatemplateandselectvariantnames: "템플릿을 선택하고 변형 이름 선택",
        ChooseaTemplate: "템플릿 선택",
        Selectvariantnamestoadd: "추가할 변형 이름 선택",
        SelectatemplatetopickvariantnamesfroYoucanaddfrommultiple: "변형 이름을 선택할 템플릿을 선택하세요. 여러 개에서 추가할 수 있습니다.",
        Loadingtemplates: "템플릿 로딩 중...",
        Backtotemplates: "템플릿으로 돌아가기",
        Selectallindividualadd: "전체 또는 개별 변형 이름을 선택하여 추가하세요.",
        VariantNames: "변형 이름",
        MediaDescription: "미디어 & 설명",
        Addattachmentsandproductnotes: "첨부파일 및 제품 메모 추가",
        ProductMedia: "제품 미디어"
    },
    AddProductGuide: {
        title: "저장 후 초기 수량 추가",
        description: "여기서는 제품에 수량 필드가 없습니다. 저장 후 '재고 입고'를 사용하여 초기 재고를 등록하세요 — 위치와 추적을 완전히 제어할 수 있습니다.",
        steps: {
            quantity: { title: "수량", sub: "초기 재고 수량 설정" },
            binLocation: { title: "빈 위치", sub: "통로, 랙, 선반 — 예: A-01-03" },
            serialNumbers: { title: "시리얼 번호", sub: "각 단위를 개별적으로 추적" },
            warehouse: { title: "창고", sub: "어느 위치에 보관되는지" },
            batchExpiry: { title: "배치 / 유효기간", sub: "배치 번호별로 재고 그룹화" }
        },
        actions: { close: "닫기" }
    },
    Remainingtranferitems: {
        NoTransferOrdersFound: "이동 주문을 찾을 수 없습니다",
        Itemshistory: "창고 간 이동한 품목은 추적 및 기록을 위해 여기에 표시됩니다.",
        CreateTransfer: "이동 생성"
    },
    ManufactureLocal: {
        TaponproducttoManufacture: "제조할 제품을 탭하세요",
        Selectproductfrombelow: "아래 목록에서 제품을 선택하세요",
        SetupANewProduct: "새 제품 설정",
        DefineAProductAdditsrawmaterial: "제품 정의 및 원재료 추가",
        ManufacturingSetup: "제조 설정",
        Pickproducttodefineitsproductiondetails: "제품을 선택하여 생산 세부 정보를 정의하세요",
        ConfigureManufacturing: "제조 구성",
        SelectRawMaterial: "원재료 선택",
        NoRawMaterials: "원재료 없음",
        Definecomponentsneededtoproduct: "이 제품을 생산하는 데 필요한 구성 요소를 정의합니다.",
        NoAdditionalCosts: "추가 비용 없음",
        Addlaboroverheadlogisticalcharges: "인건비, 오버헤드 또는 물류 비용을 추가합니다.",
        AddAdditionalCost: "추가 비용 추가",
        AddCost: "비용 추가",
        TotalPrice: "총 가격",
        SelectCharges: "항목 선택",
        EnterEstimatedCost: "추정 비용 입력",
        QtyRequried: "필요 수량",
        Manufacturing: "제조",
        Outputfinishedgoodsdestination: "완제품 목적지",
        Manufacturingquantity: "제조 수량",
        Storefinishedgoodsat: "완제품 보관 장소",
        Rawmaterials: "원재료",
        StockSelection: "재고 선택",
        AdditionalCosts: "추가 비용",
        Quantityconsume: "소비 수량",
        Totalmanufacturingcost: "총 제조 비용",
        Sumofrawmaterialcosts: "모든 원재료 비용의 합계",
        CustomManufacturingCharge: "사용자 정의 제조 비용",
        Addextralikelaboroverheadrepairs: "인건비, 오버헤드 또는 수리비와 같은 추가 비용을 추가합니다.",
        CalculatedTotal: "계산된 총계",
        AddRawMaterial: "원재료 추가",
        ConfigureRawMaterial: "원재료 구성",
        Thisoutputunit: "이는 출력 단위당 필요한 기본 수량입니다.",
        ChangeProduct: "제품 변경",
        AddtoList: "목록에 추가",
        ManufacturedSuccessfully: "성공적으로 제조되었습니다",
        Manufacture: "제조",
        EditDeleteHistory: "수정/삭제 기록",
        ManageOrder: "주문 관리",
        ManageBatch: "배치 관리",
        Paymentnotavailablehere: "여기서는 결제할 수 없습니다",
        Thisrecordisanorderorderitself: "이 레코드는 주문에서 온 것입니다. 결제는 주문에서만 기록할 수 있습니다.",
        Torecorpaymenttheorderthethere: "결제를 기록하려면 연결된 주문으로 이동하여 <b>결제 기록</b> 옵션을 사용하세요.",
        GotoOrder: "주문으로 이동"
    },
    CustomerExcel: {
        title: "고객 일괄 업로드",
        description: "Excel 파일을 사용하여 고객을 일괄 생성하려면 아래 단계를 따르십시오.",
        bulkUploadGuide: "일괄 업로드 가이드",
        step1: "1단계",
        downloadTemplate: "Excel 템플릿 다운로드",
        downloadTemplateDesc: "필요한 모든 열 헤더가 포함된 공식 템플릿을 받으십시오.",
        downloadTemplateBtn: "템플릿 다운로드",
        step2: "2단계",
        fillExcelFile: "Excel 파일 작성",
        fillExcelDesc: "각 행은 한 명의 고객을 나타냅니다. 필요에 따라 모든 열을 작성하십시오.",
        step3: "3단계",
        thingsToKeepInMind: "주의 사항",
        rulesDesc: "업로드하기 전에 오류를 방지하기 위해 파일이 다음 규칙을 따르는지 확인하십시오.",
        step4: "4단계",
        uploadYourFile: "파일 업로드",
        uploadDesc: "작성이 완료되면 아래에 파일을 업로드하십시오. 시스템이 자동으로 모든 고객을 생성합니다.",
        rules: [
            "고객당 한 행만 가능",
            "열 헤더 이름을 변경하지 마십시오",
            "국가 코드가 포함된 연락처 번호",
            ".xlsx 또는 .xls 파일만 허용됨"
        ],
        dropFileHere: "Excel 파일을 여기에 끌어다 놓으십시오",
        supports: ".xlsx 및 .xls 지원 — 최대 10MB",
        chooseFileUpload: "파일 선택 및 업로드",
        parsing: "파일 분석 중...",
        invalidFileType: "유효하지 않은 파일 형식입니다. Excel 파일을 업로드하십시오.",
        noData: "Excel에서 데이터를 찾을 수 없습니다",
        failedToRead: "Excel 파일을 읽지 못했습니다",
        unableToRead: "파일을 읽을 수 없습니다.",
        reviewTitle: "고객 데이터 검토",
        reviewSubtitle: "비즈니스에 가져오기 전 최종 확인입니다.",
        changeFile: "파일 변경",
        rowsFound: "행을 찾았습니다",
        cancel: "취소",
        finalizeImport: "완료 및 가져오기",
        importing: "가져오는 중...",
        success: "성공",
        allCustomerUploadedSuccess: "모든 고객이 성공적으로 업로드되었습니다",
        failed: "실패",
        bulkUploadFailed: "일괄 업로드가 실패했습니다",
        error: "오류",
        headers: {
            customerName: "고객명",
            phoneNumber: "연락처",
            address: "주소",
            note: "메모"
        }
    },
    SupplierExcel: {
        title: "공급업체 일괄 업로드",
        description: "Excel 파일을 사용하여 공급업체를 일괄 생성하려면 아래 단계를 따르십시오.",
        bulkUploadGuide: "일괄 업로드 가이드",
        step1: "1단계",
        downloadTemplate: "Excel 템플릿 다운로드",
        downloadTemplateDesc: "필요한 모든 열 헤더가 포함된 공식 템플릿을 받으십시오.",
        downloadTemplateBtn: "템플릿 다운로드",
        step2: "2단계",
        fillExcelFile: "Excel 파일 작성",
        fillExcelDesc: "각 행은 하나의 공급업체를 나타냅니다. 필요에 따라 모든 열을 작성하십시오.",
        step3: "3단계",
        thingsToKeepInMind: "주의 사항",
        rulesDesc: "업로드하기 전에 오류를 방지하기 위해 파일이 다음 규칙을 따르는지 확인하십시오.",
        step4: "4단계",
        uploadYourFile: "파일 업로드",
        uploadDesc: "작성이 완료되면 아래에 파일을 업로드하십시오. 시스템이 자동으로 모든 공급업체를 생성합니다.",
        rules: [
            "공급업체당 한 행만 가능",
            "열 헤더 이름을 변경하지 마십시오",
            "국가 코드가 포함된 연락처 번호",
            ".xlsx 또는 .xls 파일만 허용됨"
        ],
        dropFileHere: "Excel 파일을 여기에 끌어다 놓으십시오",
        supports: ".xlsx 및 .xls 지원 — 최대 10MB",
        chooseFileUpload: "파일 선택 및 업로드",
        parsing: "파일 분석 중...",
        invalidFileType: "유효하지 않은 파일 형식입니다. Excel 파일을 업로드하십시오.",
        noData: "Excel에서 데이터를 찾을 수 없습니다",
        failedToRead: "Excel 파일을 읽지 못했습니다",
        unableToRead: "파일을 읽을 수 없습니다.",
        reviewTitle: "공급업체 데이터 검토",
        reviewSubtitle: "비즈니스에 가져오기 전 최종 확인입니다.",
        changeFile: "파일 변경",
        rowsFound: "행을 찾았습니다",
        cancel: "취소",
        finalizeImport: "완료 및 가져오기",
        importing: "가져오는 중...",
        success: "성공",
        allSupplierUploadedSuccess: "모든 공급업체가 성공적으로 업로드되었습니다",
        failed: "실패",
        bulkUploadFailed: "일괄 업로드가 실패했습니다",
        error: "오류",
        headers: {
            supplierName: "공급업체명",
            phoneNumber: "연락처",
            bankName: "은행명",
            accountHolderName: "예금주",
            accountNumber: "계좌번호",
            note: "메모"
        }
    },
    ReplaceReturnLocal: {
        ReplacedWith: "교체 대상",
        Noreplacementhistoryfound: "교체 기록을 찾을 수 없습니다",
        Noreturnhistoryfound: "반품 기록을 찾을 수 없습니다",
        Productbeingreturned: "반품되는 제품",
        Required: "필수",
        Selectreturnedproduct: "반품된 제품 선택",
        Searchnamescanbarcode: "이름, SKU로 검색 또는 바코드 스캔",
        Browse: "찾아보기",
        Stockhandling: "재고 입고 처리",
        Stockinreturnedproduct: "반품 제품 재고 입고",
        Ontoinventory: "켜짐 — 반품된 품목이 재고에 다시 추가됩니다",
        Offreturnedonly: "꺼짐 — 품목이 반품으로만 기록됩니다",
        Usedrestock: "재입고 시 이익 조정을 계산하는 데 사용됩니다",
        Willaddedbackconfirmation: "확인 시 재고에 다시 추가됩니다",
        Returnreason: "반품 사유",
        Optional: "선택 사항",
        SelectReason: "사유 선택",
        Additionalnotes: "추가 메모",
        Describeofcustomerexplanation: "반품 품목의 상태, 눈에 보이는 손상, 고객의 설명 등을 기술해 주세요...",
        Requiredmustfilledcontinue: "계속하려면 필수 필드를 입력해야 합니다",
        Reviewdetailsbeforeconfirming: "확인하기 전에 세부 정보를 검토하세요",
        Replacementproductwilldeductedinventoryconfirmation: "교체 제품은 확인 시 재고에서 차감됩니다.",
        Choosereplacementproduct: "교체 제품 선택",
        Willdeductedfrominventoryconfirm: "확인 시 재고에서 차감됩니다",
        Thesewillattachedothereturnrecord: "이 이미지들은 반품 기록에 첨부됩니다",
        Replacementitem: "교체 품목",
        Addanotherproduct: "다른 제품 추가",
        Replacementproductwillbe: "교체 제품은 확인 시 재고에서",
        deducted: "차감",
        fromyourinventoryconfirmation: "됩니다.",
        productadjustedusingprice: "반품된 제품은 재입고되며 원래 판매 가격을 사용하여 이익이 조정됩니다.",
        Willloggedreturnedonlynotrestocked: "반품으로만 기록됩니다 — 재입고되지 않음",
        Returnonly: "반품 전용",
        Imagesofreturnedproduct: "반품된 제품 이미지",
        Returnedproductwill: "반품된 제품은 재입고되지 않으며",
        not: "반품으로만",
        berestockedloggedreturnedonly: "기록됩니다.",
        AddImage: "이미지 추가",
        STOCKIN: "재고 입고",
        LOGONLY: "기록만",
        ContinuetoReview: "검토로 이동 →",
        Confirmreplacement: "교체 확정",
        Confirmreturn: "반품 확정",
        Filldetailsbelowproceed: "계속하려면 아래 세부 정보를 입력하세요",
        Review: "검토",
        editdetails: "세부 정보 편집",
        Configurereturndetails: "반품 세부 정보 구성",
        Configurereplacementdetails: "교체 세부 정보 구성",
        SelectSource: "소스 선택",
        Returning: "반품 중",
        Replacement: "교체",
        WalkCustomer: "일반 고객",
        RETURNEDPRODUCT: "반품된 제품",
        REPLACEMENTPRODUCT: "교체 제품",
        STOCKOUT: "재고 출고",
        Netinventoryimpact: "순 재고 영향",
        Replacementitemcost: "교체 품목 원가",
        Returneditemrestockvalue: "반품 품목 재입고 가치",
        PROFITINVENTORYSUMMARY: "이익 및 재고 요약",
        Inventoryaction: "재고 조치",
        Valuededucted: "차감된 가치",
        Profitadjustment: "이익 조정",
        stockedout: " 재고 출고됨",
        restocked: " 재입고됨",
        Noaction: "조치 없음",
        Valuebeingreturned: "반품되는 가치",
        Willberestocked: "재입고 예정",
        Willbe: "예정",
        logged: "기록됨",
        ON: "켜짐",
        OFF: "꺼짐",
        Linked: "연결됨",
        Pleaseselectreturnedproduct: "반품 상품을 선택해 주세요",
        Quantityrequired: "수량은 필수입니다",
        Buyingpricerequired: "구매 가격은 필수입니다",
        Pleaseaddleastreplacementproduct: "최소 하나의 교체 상품을 추가해 주세요",
        Pleaseconfigurereturnedproductdetails: "반품 상품 세부 정보를 구성해 주세요",
        Pleaseselectcustomer: "고객을 선택해 주세요",
        Returndateisrequired: "반품 날짜는 필수입니다",
        Pleasefillallrequiredfields: "모든 필수 항목을 입력해 주세요",
        Wildeductedfrominventory: "재고에서 차감됩니다",
        Currentprice: "현재 가격",
        Defectivedamaged: "불량 / 손상",
        Wrongitemreceived: "잘못된 상품 수령",
        Customerchangedmind: "고객 변심",
        Sizefitissue: "사이즈 / 핏 문제",
        Notasdescribed: "설명과 다름",
        Other: "기타",
        Originalsaleprice: "원래 판매 가격 (이익 조정)",
        Addedbackinventory: "재고에 다시 추가됨",
        Notaddedinventory: "재고에 추가되지 않음",
        replacedwith: "교체함",
        deductedfrominventory: "재고에서 차감됨",
        RETURNWITHSTOCKIN: "반품 · 재고 입고",
        RETURNNOSTOCKIN: "반품 · 재고 미입고",
        MULTIPLEREPLACEMENTS: "다중 교체",
        SINGLEREPLACEMENT: "단일 교체",
        InternalTrackingRecordInfo: "This is a record for internal tracking. This process DOES NOT automatically update or delete related invoices, orders, or accounts.",
        ManualStepsIfNeeded: "Manual Steps (if needed):",
        ManualStep1: "Return/Delete invoice from Sale History",
        ManualStep2: "Adjust customer ledger manually",
        ManualStep3: "Update related purchase record",
        RETURNEDSTOCKIN: "반품됨 · 재고 입고",
        REPLACEMENTSTOCKOUT: "교체 · 재고 출고",
        Returnonlylogsthisentry: "반품은 이 항목만 기록합니다 —",
        nostockwillbeaddedorremoved: "재고가 추가되거나 삭제되지 않습니다",
        frominventory: "재고에서.",
        Whentousethis: "이것을 사용하는 경우:",
        UseReturnenddayrecorditemsoutsalesthatcamebackunusablewantinventory: "판매를 위해 보냈지만 손상되었거나 사용할 수 없는 상태로 돌아온 품목을 기록하려면 하루 일과 끝에 '반품'을 사용하세요 — 추적은 하고 싶지만 재고에 다시 추가할 수 없는 품목입니다.",
        Youcanviewallpastreturnentriesin: "다음에서 모든 과거 반품 항목을 볼 수 있습니다",
        ReturnHistory: "반품 내역",
        underthe: "아래의",
        Others: "기타",
        tab: "탭.",
        Negativestocktransactiondisabled: "음수 주식 거래가 비활성화되었습니다."
    },
    NewRLocal: {
        Originalsaleprice: "원래 판매 가격",
        Editinghistoryonlyinventorystaysunchanged: "기록만 편집 중 — 재고는 변경되지 않습니다.",
        Changeshereupdatethisdetailsquantitiesaffected: "여기에서의 변경 사항은 이 기록의 상세 정보(사유, 날짜, 메모)만 업데이트합니다. 실제 재고 수량, 빈 위치 및 제품 데이터는 영향을 받지 않습니다.",
        Needtofixinventorylevelsinstead: "대신 재고 수준을 수정해야 합니까?",
        AdjustStock: "재고 조정",
        Refund: "환불",
        ImportantNote: "중요 참고 사항",
        Pleasereviewbeforecontinuing: "계속하기 전에 검토해 주세요",
        Onceshippedreceivedanyupdatesmadeorder: "주문이 발송되거나 수령되면 주문에 대한 업데이트가 거래 내역에 반영되지 않습니다.",
        Thisundone: "이 작업은 주문을 영구적으로 제거합니다. 이 작업은 취소할 수 없습니다.",
        Inventorywilladjustedautomatically: "재고가 자동으로 조정되지 않습니다",
        Deletingthisreversevedshippedyouwillneed: "이를 삭제해도 재고 변경 사항은 취소되지 않습니다. 품목이 이미 수령/발송된 경우 다음이 필요합니다",
        reflectthecorrectstocklevels: "올바른 재고 수준을 반영하기 위해.",
        manuallyadjustyourinventory: "재고를 수동으로 조정",
        Addremovestockforitemsthatwereshipped: "발송된 품목에 대한 재고 추가/제거",
        Addremovestockforitemsthatwerereceived: "수령된 품목에 대한 재고 추가/제거",
        Updatecostrecordspaymentwaalreadymade: "이미 결제가 완료된 경우 비용 기록 업데이트",
        Reconcilerecordsandoutstandingpayments: "기록 및 미지급 결제 정산"
    },
    ReceivablesLocal: {
        Receivables: "미수금",
        Manageandtrackcustomerduebalances: "고객 미수금 잔액 관리 및 추적",
        Viewcustomerduebalancereport: "고객 미수금 잔액 보고서 보기",
        Viewsupplierduebalancereport: "공급자 미수금 잔액 보고서 보기",
        DueBalance: "미수 잔액",
        Unpaid: "미납",
        PartiallyPaid: "부분 납부",
        Paid: "납부 완료",
        HighestBalance: "최고 잔액",
        LowestBalance: "최저 잔액",
        Filldetailsrecordpayment: "결제를 기록하려면 세부 정보를 입력하세요",
        NewPaymentEntry: "새 결제 항목",
        EditPaymentEntry: "결제 항목 수정",
        Nosuppliersfound: "공급업체를 찾을 수 없습니다",
        Nocustomersfound: "고객을 찾을 수 없습니다",
        LowtoHigh: "낮은 순",
        HightoLow: "높은 순",
        AttachmentUploadedSc: "첨부파일 업로드 성공",
        AttachmentUploadedF: "첨부파일 업로드 실패",
        Pay: "결제",
        NoBillsFound: "청구서가 없습니다",
        Thiscustomerhasunpaidbills: "이 고객에게는 미납 청구서가 없습니다.",
        TotalDue: "총 미수금",
        BillsFound: "청구서 발견",
        DeselectAll: "모두 선택 해제",
        SelectAll: "모두 선택",
        ShowDetails: "세부정보 표시"
    },
    AssetsNewLocal: {
        Assignedon: "배정일",
        Total: "합계",
        Assigned: "배정됨",
        Remaining: "남음",
        Available: "사용 가능",
        NoSerialNumbers: "일련번호 없음",
        UpdateExistingAssetDetails: "기존 자산 세부 정보 업데이트",
        RegisterNewBusinessAsset: "신규 비즈니스 자산 등록",
        BasicInformation: "기본 정보",
        AssetDetails: "자산 세부 정보",
        Quantity: "수량",
        SerialNumbers: "일련번호",
        SerialNumberPlaceholder: "일련번호",
        AddSerialNumber: "일련번호 추가",
        SerialNumbersOptional: "일련번호는 선택 사항입니다. 최대 추가 가능 수량:",
        AssetImages: "자산 이미지",
        AdditionalNotes: "추가 메모",
        AdditionalNotesPlaceholder: "기타 세부 정보 또는 유지보수 이력...",
        Updating: "업데이트 중...",
        Adding: "추가 중...",
        ITEquipmentPlaceholder: "예: IT 장비",
        LoadingMoreActivities: "활동을 추가로 불러오는 중...",
        AssignedAssets: "배정된 자산",
        Noassetsassignedstaffmember: "이 직원에게 배정된 자산이 없습니다.",
        Assignassetstaff: "직원에게 자산 배정",
        Returnassetfromstaff: "직원으로부터 자산 반환",
        AssignmentDetails: "배정 세부정보",
        Serial: "시리얼",
        ViewAssets: "모든 자산 보기",
        ViewByStaff: "직원별 보기",
        AssignedHistory: "배정 기록",
        Returned: "반환됨",
        Returnedon: "반환일",
        ReturnedBy: "반환자",
        AssignedTo: "배정 대상",
        NoHistoryRecords: "기록 없음",
        Selectstaffmemberviewtheirassets: "자산을 보려면 직원을 선택하세요",
        Deleted: "삭제됨",
        searchPlaceholder: "이름 또는 일련번호로 자산 검색..."
    },
    InventoryCountLocale: {
        InventoryCount: "재고 실사",
        Viewinventorycountreport: "재고 실사 보고서 보기",
        ItemsCount: "품목 수",
        All: "전체",
        InProgress: "진행 중",
        Submitted: "제출됨",
        awaitingreview: "검토 대기 중",
        EditInventoryCount: "재고 실사 수정",
        NewInventoryCount: "새 재고 실사",
        Modifyinventorycountsheetdetails: "실사 시트 세부정보 수정",
        Startanewinventorycountsheet: "새 실사 시트 시작",
        GeneralInformation: "일반 정보",
        Title: "제목",
        SaveChanges: "변경사항 저장",
        Selectproductsforthisinventorycountsheet: "이 시트에 제품 선택",
        InventoryCountDetails: "재고 실사 상세",
        Inventorycountsheetdetails: "실사 시트 상세",
        Viewingdetailsforcountsheet: "실사 시트 상세 보기",
        Started: "시작됨",
        TaskSheets: "작업 시트",
        Allitems: "모든 품목",
        NotStarted: "시작 안 함",
        Completed: "완료",
        Results: "결과",
        ViewResults: "결과 보기",
        DeleteInventoryCount: "재고 실사 삭제",
        Viewingtransactionandadjustments: "거래 로그 및 재고 조정 보기",
        Productsadjusted: "조정된 제품",
        Assignee: "담당자",
        Tasksheetdetails: "작업 시트 세부정보",
        Draft: "초안",
        VariantQuantities: "변형 수량",
        AssignedProducts: "할당된 제품",
        ReturnAsset: "자산 반환",
        EditTasksheet: "작업 시트 편집",
        NewTasksheet: "새 작업 시트",
        Updatetasksheetdetails: "작업 시트 세부정보 업데이트",
        Starttasksheetforthisinventorycount: "이 실사에 대한 새 작업 시트 시작",
        TaskSheetInformation: "작업 시트 정보",
        SheetTitle: "시트 제목",
        Entersheettitle: "시트 제목 입력",
        SubmissionResult: "제출 결과",
        ReviewChanges: "변경 사항 검토",
        Viewingsubmissionresultsforthisinventorycount: "이 실사의 제출 결과 보기",
        Reviewyourinventorycountbeforesubmitting: "제출하기 전에 재고 실사를 검토하세요"
    },
    NewMissingLocale: {
        Failedtoloadcounts: "카운트 로드 실패",
        NoInventoryCounts: "재고 실사 없음",
        NoMatches: "일치하는 항목 없음",
        Therearenoinventorycountswiththestatus: "해당 상태의 재고 실사가 없습니다",
        Noinventorycountsfoundyoursearchterm: "검색어와 일치하는 재고 실사가 없습니다",
        Thereareinventorycountsrecordedyetforthisbusiness: "이 사업에 대한 재고 실사가 아직 기록되지 않았습니다"
    },
    StockinModalP: {
        StockInNow: "지금 재고 입고",
        Settheopeningquantityforthisproductrightnow: "이 제품의 초기 수량을 지금 설정하세요.",
        Addinitialstock: "초기 재고를 추가하시겠습니까?",
        dothislater: "나중에 하겠습니다",
        Productadded: "상품이 추가되었습니다!",
        isready: "준비되었습니다.",
        SeeHowItWorks: "작동 방식을 확인하세요",
        NoSalesOrdersFound: "판매 주문이 없습니다",
        NoPurchaseOrdersFound: "구매 주문이 없습니다",
        Startcreatingoutgoinginventoryrevenue: "판매 주문을 만들어 출고 재고와 수익을 추적하세요.",
        Trackrestockssupplierplace: "재고 보충과 공급자 주문을 한 곳에서 추적하세요.",
        CreateSalesOrder: "판매 주문 생성",
        CreatePurchaseOrder: "구매 주문 생성",
    }
    ,
    dialy_report: "일일 이동 보고서",
    Quotation: "견적",
    Quote: "견적",
    Assignee: "담당자",
    dayStart: "하루 시작",

    ShowTotalAmount: "총 금액",


    tutorial: {
        watchTitle: '단계별 튜토리얼 시청하기',
        watchDesc: 'YouTube 채널에서 SimplyStock 배우기',
        modalTitle: 'SimplyStock으로 앞서 나가세요',
        modalDesc: '구독하면 떨어지는 순간 새로운 튜토리얼을 받을 수 있습니다',
        feature1Title: '새로운 기능 안내',
        feature1Sub: '짧은 동영상과 함께 모든 새로운 업데이트를 설명하여 새로운 기능을 놓치지 마세요.',
        feature2Title: '빠른 사용법 동영상',
        feature2Sub: '5분 이내에 재고, 청구서, 직원 액세스 등을 설정할 수 있습니다.',
        feature3Title: '즉시 알림',
        feature3Sub: '새로운 튜토리얼이 공개되는 순간 알림을 받으세요 — 자신만의 속도로 학습하세요',
        feature4Title: '100% 무료, 항상',
        feature4Sub: '모든 튜토리얼은 영원히 무료입니다 — 로그인이나 구독이 필요하지 않습니다',
        subscribeBtn: 'SimplyStock 구독하기',
        maybeLater: '나중에'
    }
    ,
    dailyCashReport: {
        "title": "일일 현금 보고서",
        "subtitle": "누가 언제 무엇을 지불했고 무엇이 미결제인지 — 판매 세부 정보에서 그룹화됨.",
        "totalSales": "총 매출",
        "cashReceived": "총 수신",
        "outstanding": "미결제액",
        "collectionRate": "수금률",
        "grandTotalAllDates": "총계 (모든 날짜)",
        "totalLabel": "합계",
        "loading": "로딩 중...",
        "noData": "선택한 기간에 대한 데이터를 찾을 수 없습니다.",
        "loadingMore": "더 불러오는 중..."
    },
    dailyCashReportColumns: {
        "date": "날짜",
        "customer": "고객",
        "productsSold": "판매된 상품",
        "products": "상품",
        "salesAmount": "판매 금액",
        "sales": "판매",
        "received": "총 수신",
        "receivedShort": "수령액",
        "debited": "원장에 차변 기입",
        "due": "지불 기한",
        "paymentModes": "결제 방법",
        "mode": "방법"
    }
}

export default ko;
